

// // import React, { useState, useEffect, useRef, useMemo } from "react";
// // import axios from "axios";
// // import { Link } from "react-router-dom";
// // import { useLoader } from '../../../../context/LoaderProvider.jsx';
// // import {
// //     getEngineeringVendorDetailsAPI,
// //     approveEngineeringVendorAPI,
// //     getAllEngineeringVendorsAPI,
// //     updateFoodVendorDetailsAPI,
// //     updateFoodVendorStatusAPI,
// // } from "../../../Servicefile/clientManagementService.jsx";
// // // Add this helper function at the top (outside component)
// // const normalizeImageUrl = (url) => {
// //     if (!url || url === "N/A" || typeof url !== 'string') return null;

// //     // If it's already a full URL, return as is
// //     if (url.startsWith('http')) {
// //         return url;
// //     }

// //     // Remove leading slash if present and prepend base URL
// //     const cleanUrl = url.replace(/^\//, '');
// //     // Use the correct image server URL
// //     return `http://img.maamaas.com:8080/${cleanUrl}`;
// // };

// // const getDefaultClientDetailsRows = () => [
// //     { key: "Owner Name", value: "", isUpload: false },
// //     { key: "Business Plan", value: "", isUpload: false },
// //     { key: "Company Name", value: "", isUpload: false },
// //     { key: "Register Documents", value: "", isUpload: true },
// //     { key: "Phone No", value: "", isUpload: false },
// //     { key: "Email ID", value: "", isUpload: false },
// //     {
// //         key: "Bank Details",
// //         value: {
// //             holderName: "",
// //             branchName: "",
// //             accountNumber: "",
// //             ifscCode: "",
// //         },
// //         isUpload: false,
// //     },
// //     { key: "Passbook", value: "", isUpload: true },
// //     { key: "AADHAR CARD NO", value: "", isUpload: false },
// //     { key: "PAN CARD NO", value: "", isUpload: false },
// //     { key: "Website", value: "", isUpload: false },
// //     { key: "GST No.", value: "", isUpload: false },
// // ];

// // const STATUS_FIELD_MAP = {
// //     "Owner Name": "ownerNameStatus",
// //     "Business Plan": "businessPlanStatus",
// //     "Company Name": "registeredNameStatus",
// //     "Register Documents": "registeredDocumentsStatus",
// //     "Phone No": "mobileNumberStatus",
// //     "Email ID": "emailStatus",
// //     "AADHAR CARD NO": "aadharNumberStatus",
// //     "PAN CARD NO": "panCardStatus",
// //     "Website": "websiteNameStatus",
// //     "GST No.": "gstNumberStatus",
// //     "Trade License": "tradeLicenseStatus",
// //     "FSSI License": "fssaiLicenseStatus",
// //     "Labour License": "labourLicenseStatus",
// //     "Bank Details": "blankChequeStatus",
// //     "Passbook": "passbookStatus",
// //     "Address": "addressStatus",
// //     "Order Type": "orderTypeStatus",
// //     "Business Vertical": "businessVerticalStatus",
// //     "Rating": "ratingStatus",
// //     "Trade License Number": "tradeLicenseStatus",
// //     "FSSAI License Number": "fssaiLicenseStatus",
// //     "Labour License Number": "labourLicenseStatus",
// // };

// // // Order Type options
// // const orderTypeOptions = [
// //     "DINE_IN",
// //     "TAKEAWAY",
// //     "DELIVERY",
// //     "TABLE_DINE_IN"
// // ];

// // // Business Plan options
// // const businessPlanOptions = [
// //     "HOTEL",
// //     "RESTAURANT",
// //     "CAFE",
// //     "CLOUD_KITCHEN",
// //     "FOOD_COURT",
// //     "STREET_FOOD",
// //     "BAKERY"
// // ];

// // // Business Vertical options
// // const businessVerticalOptions = [
// //     "FOOD_AND_BEVERAGES",
// //     "CATERINGS_SERVICES",
// //     "LOGISTICS_SUPPLY",
// //     "FRESH_GROCERIES"
// // ];

// // // Rating options
// // const ratingOptions = [
// //     { value: 0, label: "0 - Not Rated" },
// //     { value: 1, label: "1 ★" },
// //     { value: 1.5, label: "1.5 ★" },
// //     { value: 2, label: "2 ★" },
// //     { value: 2.5, label: "2.5 ★" },
// //     { value: 3, label: "3 ★" },
// //     { value: 3.5, label: "3.5 ★" },
// //     { value: 4, label: "4 ★" },
// //     { value: 4.5, label: "4.5 ★" },
// //     { value: 5, label: "5 ★" }
// // ];

// // // Safe date conversion utility
// // const safeDateToISOString = (dateString) => {
// //     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return "";

// //     return date.toISOString().split("T")[0];
// // };

// // // Safe date display utility
// // const safeDateDisplay = (dateString) => {
// //     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return "N/A";

// //     return date.toLocaleDateString();
// // };

// // // Updated hasValidData function
// // const hasValidData = (row, vendorDetails) => {
// //     if (!row) return false;

// //     const field = row.key;
// //     const value = row.value;

// //     // Special case for empty arrays
// //     if (Array.isArray(value)) {
// //         return value.length > 0 && value[0] !== "N/A";
// //     }

// //     // Check if the value exists and is not empty/"N/A"
// //     if (typeof value === 'string') {
// //         return value && value !== "N/A" && value.trim() !== "";
// //     }

// //     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
// //         // For Address, Bank Details, License objects
// //         if (field === "Address" || field === "Bank Details" ||
// //             field === "Trade License" || field === "FSSI License" || field === "Labour License") {
// //             // Check if any property has valid data
// //             return Object.values(value).some(val =>
// //                 val && val !== "N/A" && val.toString().trim() !== ""
// //             );
// //         }
// //         // For other objects, just check if it's not empty
// //         return Object.keys(value).length > 0;
// //     }

// //     // For numbers (like rating)
// //     if (typeof value === 'number') {
// //         return value !== undefined && value !== null;
// //     }

// //     // For fields that are just text labels (like "Registered Documents", "Passbook Image")
// //     if (value === "Registered Documents" || value === "Passbook Image") {
// //         // Check if there are images for these fields
// //         const hasImages = row.images && row.images.length > 0;
// //         return hasImages;
// //     }

// //     return false;
// // };

// // // Updated isFieldVerified function
// // const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
// //     const normalisedKey = rowKey.trim().replace(/\.$/, "");
// //     const statusField = STATUS_FIELD_MAP[normalisedKey];

// //     // If there's a status field in the backend, check its value
// //     if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
// //         return vendorDetails[statusField] === true;
// //     }

// //     // Create a row object to pass to hasValidData
// //     const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

// //     // Always auto-verify these specific fields if they have data
// //     const alwaysAutoVerifyFields = [
// //         "Business Vertical",
// //         "Order Type",
// //         "Address",
// //         "Rating",
// //         "Business Plan",
// //         "Website",
// //         "Phone No",
// //         "Email ID",
// //         "GST No.",
// //         "Trade License Number",
// //         "FSSAI License Number",
// //         "Labour License Number",
// //         "Owner Name",
// //         "Company Name",
// //         "AADHAR CARD NO",
// //         "PAN CARD NO"
// //     ];

// //     if (alwaysAutoVerifyFields.includes(rowKey)) {
// //         return hasValidData(rowForValidation, vendorDetails);
// //     }

// //     // For document/image fields, check both data and images
// //     const documentFields = [
// //         "Register Documents",
// //         "Trade License",
// //         "FSSI License",
// //         "Labour License",
// //         "Bank Details",
// //         "Passbook"
// //     ];

// //     if (documentFields.includes(rowKey)) {
// //         // For document fields, require images
// //         const hasImages = rowImages && rowImages.length > 0;
// //         return hasImages;
// //     }

// //     return false;
// // };

// // const isFieldRejected = (rowKey, vendorDetails) => {
// //     const normalisedKey = rowKey.trim().replace(/\.$/, "");
// //     const statusField = STATUS_FIELD_MAP[normalisedKey];

// //     if (!statusField || !vendorDetails) return false;

// //     return vendorDetails[statusField] === false;
// // };

// // // New function to check if a field can be verified
// // const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
// //     // Check if there's valid data
// //     return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
// // };

// // /* ---------------- component ---------------- */
// // const Engineeringpaidclinets = () => {
// //     /* -------- list‑screen state -------- */
// //     const [rolesData, setRolesData] = useState([]);
// //     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
// //     const { showLoader, hideLoader } = useLoader();

// //     // Filter states
// //     const [searchType, setSearchType] = useState("vendorId");
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const [cityFilter, setCityFilter] = useState("");
// //     const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
// //     const [filteredData, setFilteredData] = useState([]);

// //     /* -------- detail‑screen state -------- */
// //     const [selectedClient, setSelectedClient] = useState(null);
// //     const [vendorDetails, setVendorDetails] = useState(null);
// //     const [vendorNotFound, setVendorNotFound] = useState(false);
// //     const [vendorError, setVendorError] = useState(null);
// //     const [loading, setLoading] = useState(false);

// //     const [rows, setRows] = useState(getDefaultClientDetailsRows());
// //     const [verifiedRows, setVerifiedRows] = useState([]);
// //     const [rejectedRows, setRejectedRows] = useState([]);
// //     const [isApproved, setIsApproved] = useState(false);
// //     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

// //     const fileInputRef = useRef(null);
// //     const [vendorData, setVendorData] = useState({});
// //     const [rowId, setRowId] = useState(null);

// //     // Screen resize effect
// //     useEffect(() => {
// //         const handleResize = () => setScreenWidth(window.innerWidth);
// //         window.addEventListener("resize", handleResize);
// //         return () => window.removeEventListener("resize", handleResize);
// //     }, []);

// //     const getCurrentVendorId = () => {
// //         return (
// //             selectedClient?.vendorId ||
// //             selectedClient?.vendorEnquiry?.vendorId ||
// //             vendorDetails?.vendorId ||
// //             null
// //         );
// //     };

// //     const vendorId = getCurrentVendorId();

// //     const handleImageError = (imageUrl, fieldName, index) => {
// //         const errorKey = `${fieldName}-${index}`;
// //         setImageLoadErrors(prev => new Set([...prev, errorKey]));
// //     };

// //     const handleImageLoad = (imageUrl, fieldName, index) => {
// //         const errorKey = `${fieldName}-${index}`;
// //         setImageLoadErrors(prev => {
// //             const newSet = new Set(prev);
// //             newSet.delete(errorKey);
// //             return newSet;
// //         });
// //     };

// //     const isImageFailed = (fieldName, index) => {
// //         return imageLoadErrors.has(`${fieldName}-${index}`);
// //     };


// //     const fetchVendorDetails =
// //         async (vendorId) => {

// //             if (!vendorId)
// //                 return;

// //             setLoading(true);

// //             setVendorNotFound(
// //                 false
// //             );

// //             setVendorError(
// //                 null
// //             );

// //             try {

// //                 const result =
// //                     await getEngineeringVendorDetailsAPI(
// //                         vendorId
// //                     );

// //                 if (
// //                     result.vendorNotFound
// //                 ) {

// //                     setVendorNotFound(
// //                         true
// //                     );

// //                     setVendorDetails(
// //                         null
// //                     );

// //                     setVendorError(
// //                         result.error
// //                     );

// //                     return;
// //                 }

// //                 setVendorDetails(
// //                     result.data
// //                 );

// //                 setVendorNotFound(
// //                     false
// //                 );

// //                 setVendorError(
// //                     null
// //                 );

// //             } catch (err) {

// //                 console.error(
// //                     "❌ get-vendor-details error:",
// //                     err
// //                 );

// //                 setVendorNotFound(
// //                     true
// //                 );

// //                 setVendorDetails(
// //                     null
// //                 );

// //                 setVendorError(
// //                     "Vendor not registered"
// //                 );

// //             } finally {

// //                 setLoading(false);
// //             }
// //         };


// //     const handleApproveAll =
// //         async () => {

// //             try {

// //                 const vendorId =
// //                     selectedClient?.vendorId ||
// //                     vendorDetails?.vendorId;

// //                 if (!vendorId) {

// //                     alert(
// //                         "❌ Vendor ID not found"
// //                     );

// //                     return;
// //                 }

// //                 await approveEngineeringVendorAPI(
// //                     vendorId
// //                 );

// //                 setVendorDetails(
// //                     (prev) => ({
// //                         ...prev,

// //                         approvalStatus:
// //                             true,

// //                         approvalRemarks:
// //                             "Approved",
// //                     })
// //                 );

// //                 alert(
// //                     "✅ Vendor Approved Successfully"
// //                 );

// //             } catch (err) {

// //                 console.error(
// //                     "❌ Approval Error:",
// //                     err
// //                 );

// //                 alert(
// //                     "❌ Failed to approve vendor"
// //                 );
// //             }
// //         };



// //     const handleSaveRow =
// //         async (rowIndex) => {

// //             try {

// //                 const vendorId =
// //                     selectedClient?.vendorId;

// //                 if (!vendorId) {

// //                     console.error(
// //                         "Vendor ID not found"
// //                     );

// //                     return;
// //                 }

// //                 const row =
// //                     rows[rowIndex];

// //                 const formData =
// //                     new FormData();

// //                 const vendorData =
// //                     {};

// //                 const fieldMapping = {
// //                     "Owner Name":
// //                         "ownerName",

// //                     "Phone No":
// //                         "mobileNumber",

// //                     Website:
// //                         "websiteName",

// //                     "Email ID":
// //                         "email",

// //                     "Company Name":
// //                         "registeredName",

// //                     "AADHAR CARD NO":
// //                         "aadharNumber",

// //                     "PAN CARD NO":
// //                         "panCardNumber",

// //                     "GST No.":
// //                         "gstNumber",

// //                     "Order Type":
// //                         "orderTypes",

// //                     "Business Plan":
// //                         "businessPlan",

// //                     "Trade License Number":
// //                         "tradeLicenseNumber",

// //                     "FSSAI License Number":
// //                         "fssaiLicenseNumber",

// //                     "Labour License Number":
// //                         "labourLicenseNumber",

// //                     Rating:
// //                         "rating",
// //                 };

// //                 const backendFieldName =
// //                     fieldMapping[
// //                     row.key
// //                     ];

// //                 if (
// //                     backendFieldName &&
// //                     row.value
// //                 ) {

// //                     if (
// //                         row.key ===
// //                         "Order Type"
// //                     ) {

// //                         vendorData[
// //                             backendFieldName
// //                         ] =
// //                             Array.isArray(
// //                                 row.value
// //                             )
// //                                 ? row.value
// //                                 : [
// //                                     row.value,
// //                                 ];

// //                     } else if (
// //                         row.key ===
// //                         "Rating"
// //                     ) {

// //                         vendorData[
// //                             backendFieldName
// //                         ] =
// //                             parseFloat(
// //                                 row.value
// //                             ) || 0;

// //                     } else if (
// //                         row.value !==
// //                         "N/A"
// //                     ) {

// //                         vendorData[
// //                             backendFieldName
// //                         ] =
// //                             row.value;
// //                     }
// //                 }

// //                 formData.append(
// //                     "vendorData",

// //                     new Blob(
// //                         [
// //                             JSON.stringify(
// //                                 vendorData
// //                             ),
// //                         ],
// //                         {
// //                             type:
// //                                 "application/json",
// //                         }
// //                     )
// //                 );

// //                 if (
// //                     row.images &&
// //                     row.images.length > 0
// //                 ) {

// //                     row.images.forEach(
// //                         (
// //                             img,
// //                             idx
// //                         ) => {

// //                             if (
// //                                 img.file
// //                             ) {

// //                                 const imageFieldName =
// //                                     getImageFieldName(
// //                                         row.key,
// //                                         idx
// //                                     );

// //                                 formData.append(
// //                                     imageFieldName,
// //                                     img.file
// //                                 );
// //                             }
// //                         }
// //                     );
// //                 }

// //                 await updateFoodVendorDetailsAPI(
// //                     vendorId,
// //                     formData
// //                 );

// //                 alert(
// //                     "Data updated successfully!"
// //                 );

// //                 setRows(
// //                     (prev) =>
// //                         prev.map(
// //                             (
// //                                 r,
// //                                 idx
// //                             ) =>
// //                                 idx ===
// //                                     rowIndex
// //                                     ? {
// //                                         ...r,

// //                                         isEditing:
// //                                             false,
// //                                     }
// //                                     : r
// //                         )
// //                 );

// //                 fetchVendorDetails(
// //                     vendorId
// //                 );

// //             } catch (err) {

// //                 console.error(
// //                     "Error updating vendor:",
// //                     err
// //                 );

// //                 alert(
// //                     "Error updating data: " +
// //                     (err.response
// //                         ?.data
// //                         ?.message ||
// //                         err.message)
// //                 );
// //             }
// //         };

// //     const getImageFieldName = (rowKey, imageIndex) => {
// //         const fieldMap = {
// //             "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
// //             "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
// //             "PAN CARD NO": "panCard",
// //             "Trade License": "tradeLicense",
// //             "FSSI License": "fssaiLicense",
// //             "Labour License": "labourLicense",
// //             "Bank Details": "blankCheque",
// //             "Passbook": "passbook",
// //             "Company Name": "companyLogo",
// //         };

// //         return fieldMap[rowKey] || `image${imageIndex + 1}`;
// //     };

// //     const handleVerifyy =
// //         async (i) => {

// //             const normalisedKey =
// //                 rows[
// //                     i
// //                 ].key
// //                     .trim()
// //                     .replace(
// //                         /\.$/,
// //                         ""
// //                     );

// //             const statusField =
// //                 STATUS_FIELD_MAP[
// //                 normalisedKey
// //                 ];

// //             if (!statusField)
// //                 return;

// //             const vendorId =
// //                 getCurrentVendorId();

// //             if (!vendorId)
// //                 return alert(
// //                     "Vendor ID is missing"
// //                 );

// //             try {

// //                 const vendorData = {
// //                     ownerNameStatus:
// //                         vendorDetails?.ownerNameStatus ??
// //                         false,

// //                     businessPlanStatus:
// //                         vendorDetails?.businessPlanStatus ??
// //                         false,

// //                     registeredNameStatus:
// //                         vendorDetails?.registeredNameStatus ??
// //                         false,

// //                     registeredDocumentsStatus:
// //                         vendorDetails?.registeredDocumentsStatus ??
// //                         false,

// //                     mobileNumberStatus:
// //                         vendorDetails?.mobileNumberStatus ??
// //                         false,

// //                     emailStatus:
// //                         vendorDetails?.emailStatus ??
// //                         false,

// //                     aadharNumberStatus:
// //                         vendorDetails?.aadharNumberStatus ??
// //                         false,

// //                     panCardStatus:
// //                         vendorDetails?.panCardStatus ??
// //                         false,

// //                     websiteNameStatus:
// //                         vendorDetails?.websiteNameStatus ??
// //                         false,

// //                     gstNumberStatus:
// //                         vendorDetails?.gstNumberStatus ??
// //                         false,

// //                     tradeLicenseStatus:
// //                         vendorDetails?.tradeLicenseStatus ??
// //                         false,

// //                     fssaiLicenseStatus:
// //                         vendorDetails?.fssaiLicenseStatus ??
// //                         false,

// //                     labourLicenseStatus:
// //                         vendorDetails?.labourLicenseStatus ??
// //                         false,

// //                     blankChequeStatus:
// //                         vendorDetails?.blankChequeStatus ??
// //                         false,

// //                     passbookStatus:
// //                         vendorDetails?.passbookStatus ??
// //                         false,

// //                     addressStatus:
// //                         vendorDetails?.addressStatus ??
// //                         false,

// //                     orderTypeStatus:
// //                         vendorDetails?.orderTypeStatus ??
// //                         false,

// //                     businessVerticalStatus:
// //                         vendorDetails?.businessVerticalStatus ??
// //                         false,

// //                     ratingStatus:
// //                         vendorDetails?.ratingStatus ??
// //                         false,

// //                     [statusField]:
// //                         true,
// //                 };

// //                 await updateFoodVendorStatusAPI(
// //                     vendorId,
// //                     vendorData
// //                 );

// //                 setVendorDetails(
// //                     (prev) => ({
// //                         ...prev,

// //                         [statusField]:
// //                             true,
// //                     })
// //                 );

// //                 await fetchVendorDetails(
// //                     vendorId
// //                 );

// //                 alert(
// //                     "Vendor data verified successfully!"
// //                 );

// //             } catch (err) {

// //                 console.error(
// //                     "❌ Verify error:",
// //                     err
// //                 );

// //                 alert(
// //                     `Failed to update status: ${err.message}`
// //                 );
// //             }
// //         };



// //     const handleReject =
// //         async (i) => {

// //             const normalisedKey =
// //                 rows[
// //                     i
// //                 ].key
// //                     .trim()
// //                     .replace(
// //                         /\.$/,
// //                         ""
// //                     );

// //             const statusField =
// //                 STATUS_FIELD_MAP[
// //                 normalisedKey
// //                 ];

// //             if (!statusField)
// //                 return;

// //             const vendorId =
// //                 getCurrentVendorId();

// //             if (!vendorId)
// //                 return alert(
// //                     "Vendor ID missing"
// //                 );

// //             try {

// //                 const vendorData = {
// //                     ownerNameStatus:
// //                         vendorDetails?.ownerNameStatus ??
// //                         false,

// //                     businessPlanStatus:
// //                         vendorDetails?.businessPlanStatus ??
// //                         false,

// //                     registeredNameStatus:
// //                         vendorDetails?.registeredNameStatus ??
// //                         false,

// //                     registeredDocumentsStatus:
// //                         vendorDetails?.registeredDocumentsStatus ??
// //                         false,

// //                     mobileNumberStatus:
// //                         vendorDetails?.mobileNumberStatus ??
// //                         false,

// //                     emailStatus:
// //                         vendorDetails?.emailStatus ??
// //                         false,

// //                     aadharNumberStatus:
// //                         vendorDetails?.aadharNumberStatus ??
// //                         false,

// //                     panCardStatus:
// //                         vendorDetails?.panCardStatus ??
// //                         false,

// //                     websiteNameStatus:
// //                         vendorDetails?.websiteNameStatus ??
// //                         false,

// //                     gstNumberStatus:
// //                         vendorDetails?.gstNumberStatus ??
// //                         false,

// //                     tradeLicenseStatus:
// //                         vendorDetails?.tradeLicenseStatus ??
// //                         false,

// //                     fssaiLicenseStatus:
// //                         vendorDetails?.fssaiLicenseStatus ??
// //                         false,

// //                     labourLicenseStatus:
// //                         vendorDetails?.labourLicenseStatus ??
// //                         false,

// //                     blankChequeStatus:
// //                         vendorDetails?.blankChequeStatus ??
// //                         false,

// //                     passbookStatus:
// //                         vendorDetails?.passbookStatus ??
// //                         false,

// //                     addressStatus:
// //                         vendorDetails?.addressStatus ??
// //                         false,

// //                     orderTypeStatus:
// //                         vendorDetails?.orderTypeStatus ??
// //                         false,

// //                     businessVerticalStatus:
// //                         vendorDetails?.businessVerticalStatus ??
// //                         false,

// //                     ratingStatus:
// //                         vendorDetails?.ratingStatus ??
// //                         false,

// //                     [statusField]:
// //                         false,
// //                 };

// //                 await updateFoodVendorStatusAPI(
// //                     vendorId,
// //                     vendorData
// //                 );

// //                 setVendorDetails(
// //                     (prev) => ({
// //                         ...prev,

// //                         [statusField]:
// //                             false,
// //                     })
// //                 );

// //                 await fetchVendorDetails(
// //                     vendorId
// //                 );

// //                 alert(
// //                     "Vendor status rejected successfully!"
// //                 );

// //             } catch (err) {

// //                 console.error(
// //                     "❌ Reject error:",
// //                     err
// //                 );

// //                 alert(
// //                     `Failed to reject status: ${err.message}`
// //                 );
// //             }
// //         };

// //     // Fetch subscriptions from new API endpoint
// //     useEffect(() => {

// //         showLoader();

// //         getAllEngineeringVendorsAPI()

// //             .then(
// //                 (subscriptions) => {

// //                     setRolesData(
// //                         subscriptions
// //                     );

// //                     setFilteredData(
// //                         subscriptions
// //                     );

// //                     if (
// //                         subscriptions.length > 0
// //                     ) {

// //                         const vendorId =
// //                             subscriptions[0]
// //                                 ?.vendorId;

// //                         if (vendorId) {

// //                             fetchVendorDetails(
// //                                 vendorId
// //                             );
// //                         }
// //                     }
// //                 }
// //             )

// //             .catch((err) =>
// //                 console.error(
// //                     "Payment fetch error:",
// //                     err
// //                 )
// //             )

// //             .finally(() => {
// //                 hideLoader();
// //             });

// //     }, []);

// //     // Apply filters
// //     useEffect(() => {
// //         let result = rolesData;

// //         // Apply city filter
// //         if (cityFilter) {
// //             result = result.filter(item => item.city === cityFilter);
// //         }

// //         // Apply business vertical filter
// //         if (businessVerticalFilter) {
// //             result = result.filter(item => item.businessVertical === businessVerticalFilter);
// //         }

// //         // Apply search query
// //         if (searchQuery.trim()) {
// //             const query = searchQuery.toLowerCase().trim();
// //             result = result.filter(item => {
// //                 // Get the field value based on searchType
// //                 let fieldValue;

// //                 // Handle different field names in the subscription data
// //                 if (searchType === "vendorId") {
// //                     fieldValue = item.vendorId;
// //                 } else if (searchType === "phoneNumber") {
// //                     fieldValue = item.customerMobile;
// //                 } else if (searchType === "email") {
// //                     fieldValue = item.email || item.customerEmail;
// //                 } else if (searchType === "name") {
// //                     fieldValue = item.customerName;
// //                 } else if (searchType === "city") {
// //                     fieldValue = item.city;
// //                 } else if (searchType === "businessVertical") {
// //                     fieldValue = item.businessVertical;
// //                 } else {
// //                     fieldValue = item[searchType];
// //                 }

// //                 if (!fieldValue) return false;

// //                 // For phone number search, clean non-digits
// //                 if (searchType === "phoneNumber") {
// //                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
// //                     const cleanQuery = query.replace(/\D/g, '');
// //                     return fieldValue.toString().toLowerCase().includes(query) ||
// //                         cleanPartnerMobile.includes(cleanQuery);
// //                 }

// //                 // For other fields
// //                 return fieldValue.toString().toLowerCase().includes(query);
// //             });
// //         }

// //         setFilteredData(result);
// //     }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery]);

// //     // Get unique values for filter dropdowns
// //     const uniqueCities = useMemo(() => {
// //         const cities = rolesData.map(item => item.city).filter(Boolean);
// //         return [...new Set(cities)].sort();
// //     }, [rolesData]);

// //     const uniqueBusinessVerticals = useMemo(() => {
// //         const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
// //         return [...new Set(verticals)].sort();
// //     }, [rolesData]);

// //     // Clear all filters
// //     const clearAllFilters = () => {
// //         setSearchQuery("");
// //         setCityFilter("");
// //         setBusinessVerticalFilter("");
// //         setSearchType("vendorId");
// //     };

// //     // Get placeholder text based on search type
// //     const getPlaceholderText = () => {
// //         switch (searchType) {
// //             case "vendorId": return "Search Vendor ID";
// //             case "name": return "Search Customer Name";
// //             case "email": return "Search Email";
// //             case "phoneNumber": return "Search Mobile Number";
// //             case "city": return "Search City";
// //             case "businessVertical": return "Search Business Vertical";
// //             default: return "Search...";
// //         }
// //     };

// //     // Search options - Added businessVertical
// //     const searchOptions = [
// //         { value: "vendorId", label: "Vendor ID" },
// //         { value: "name", label: "Customer Name" },
// //         { value: "email", label: "Email" },
// //         { value: "phoneNumber", label: "Mobile Number" },
// //         { value: "city", label: "City" },
// //         { value: "businessVertical", label: "Business Vertical" }
// //     ];

// //     useEffect(() => {
// //         if (!selectedClient) {
// //             setRows(getDefaultClientDetailsRows());
// //             setVerifiedRows([]);
// //             setRejectedRows([]);
// //             setIsApproved(false);
// //             setImageLoadErrors(new Set());
// //             return;
// //         }

// //         const merged = { ...selectedClient, ...(vendorDetails || {}) };

// //         // REQUIRED Image mapping only - using normalizeImageUrl
// //         const imageMap = {
// //             "Register Documents": [
// //                 normalizeImageUrl(merged.registeredDocumentsFront),
// //                 normalizeImageUrl(merged.registeredDocumentsBack)
// //             ].filter(url => url),
// //             "AADHAR CARD NO": [
// //                 normalizeImageUrl(merged.aadharPhotoFront),
// //                 normalizeImageUrl(merged.aadharPhotoBack)
// //             ].filter(url => url),
// //             "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
// //             "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
// //             "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
// //             "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
// //             "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
// //             "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
// //             "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
// //         };

// //         const newRows = [
// //             { key: "Vendor ID", value: merged.vendorId || "N/A" },

// //             { key: "City", value: merged.city || "N/A" },
// //             { key: "State", value: merged.state || "N/A" },
// //             { key: "Pincode", value: merged.pincode || "N/A" },

// //             {
// //                 key: "Address",
// //                 value: {
// //                     doorNo: merged.doorNumber || "N/A",
// //                     street: merged.addressLine || "N/A",
// //                     landmark: merged.landMark || "N/A",
// //                     city: merged.city || "N/A",
// //                     state: merged.state || "N/A",
// //                     pincode: merged.pincode || "N/A",
// //                     latitude: merged.latitude?.toString() || "N/A",
// //                     longitude: merged.longitude?.toString() || "N/A",
// //                 },
// //             },

// //             {
// //                 key: "Bank Details",
// //                 value: {
// //                     accountNumber: merged.bankAccountNumber || "N/A",
// //                     ifscCode: merged.ifscCode || "N/A",
// //                     bankName: merged.bankName || "N/A",
// //                     branchName: merged.branchName || "N/A",
// //                 },
// //             },
// //             { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
// //             { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },

// //             // Trade License Number
// //             { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
// //             {
// //                 key: "Trade License",
// //                 value: {
// //                     startDate: merged.tradeLicenseStartDate || "N/A",
// //                     endDate: merged.tradeLicenseEndDate || "N/A",
// //                 },
// //             },



// //             // Labour License Number
// //             { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
// //             {
// //                 key: "Labour License",
// //                 value: {
// //                     startDate: merged.labourStartDate || "N/A",
// //                     endDate: merged.labourEndDate || "N/A",
// //                 },
// //             },

// //             { key: "GST No.", value: merged.gstNumber || "N/A" },

// //             {
// //                 key: "Bank Details",
// //                 value: {
// //                     holderName: merged.holderName || merged.accountHolderName || "N/A",
// //                     branchName: merged.branchName || merged.bankName || "N/A",
// //                     accountNumber: merged.accountNumber || merged.accountNo || "N/A",
// //                     ifscCode: merged.ifscCode || "N/A",
// //                 },
// //             },

// //             { key: "Passbook", value: "Passbook Image" },

// //             { key: "Approval Status", value: merged.approvalStatus ? "Approved" : "Pending" },
// //             { key: "Remarks", value: merged.approvalRemarks || "N/A" },
// //         ];

// //         const updatedRows = newRows.map((row) => ({
// //             ...row,
// //             images: imageMap[row.key] || [],
// //         }));

// //         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
// //         setVerifiedRows([]);
// //         setRejectedRows([]);
// //         setIsApproved(false);
// //         setImageLoadErrors(new Set());
// //     }, [selectedClient, vendorDetails]);

// //     const handleViewClick = (client) => {
// //         setSelectedClient(client);
// //         const vendorId = client?.vendorId;
// //         setVendorNotFound(false);
// //         setVendorError(null);
// //         fetchVendorDetails(vendorId);
// //     };

// //     const handleBackClick = () => {
// //         setSelectedClient(null);
// //         setVendorNotFound(false);
// //         setVendorError(null);
// //     };

// //     const handleFileChange = (e, index) => {
// //         const fileName = e.target.files[0]?.name || "";
// //         const updated = [...rows];
// //         updated[index].value = fileName;
// //         setRows(updated);
// //     };

// //     // Clean Image Display Component with "-" for missing images
// //     const ImageDisplay = ({ images, fieldName }) => {
// //         if (!images || images.length === 0) {
// //             return (
// //                 <div className="text-center">
// //                     <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
// //                 </div>
// //             );
// //         }

// //         return (
// //             <div className="d-flex justify-content-center gap-2 flex-wrap">
// //                 {images.map((img, idx) => {
// //                     const imageUrl = typeof img === 'string' ? img : img.url;
// //                     const hasFailed = isImageFailed(fieldName, idx);

// //                     if (hasFailed || !imageUrl) {
// //                         return (
// //                             <div key={idx} className="text-center">
// //                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
// //                             </div>
// //                         );
// //                     }

// //                     return (
// //                         <div key={idx} className="text-center position-relative">
// //                             <img
// //                                 src={imageUrl}
// //                                 alt={`${fieldName}-${idx}`}
// //                                 style={{
// //                                     width: fieldName === "Company Name" ? "80px" : "60px",
// //                                     height: fieldName === "Company Name" ? "80px" : "60px",
// //                                     borderRadius: "6px",
// //                                     objectFit: "cover",
// //                                     border: "1px solid #dee2e6",
// //                                 }}
// //                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
// //                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
// //                             />
// //                         </div>
// //                     );
// //                 })}
// //             </div>
// //         );
// //     };

// //     return (
// //         <div className="container-fluid">
// //             <div className="row">
// //                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
// //                     <div className="client" style={{ overflowY: "auto", height: "450px" }}>
// //                         {!selectedClient ? (
// //                             <>
// //                                 {/* Filter Controls */}
// //                                 <div className="row g-2 mb-3 align-items-center me-0">
// //                                     {/* Search Type Dropdown and Search Input */}
// //                                     <div className="col-md-auto col-12">
// //                                         <div className="d-flex align-items-center" style={{ gap: '10px' }}>
// //                                             {/* Search Type Dropdown */}
// //                                             <div style={{ minWidth: '150px' }}>
// //                                                 <select
// //                                                     className="form-select"
// //                                                     value={searchType}
// //                                                     onChange={(e) => setSearchType(e.target.value)}
// //                                                     style={{ height: "40px" }}
// //                                                 >
// //                                                     {searchOptions.map(option => (
// //                                                         <option key={option.value} value={option.value}>
// //                                                             {option.label}
// //                                                         </option>
// //                                                     ))}
// //                                                 </select>
// //                                             </div>

// //                                             {/* Search Input */}
// //                                             <div style={{ minWidth: '200px' }}>
// //                                                 <input
// //                                                     type="text"
// //                                                     className="form-control"
// //                                                     placeholder={getPlaceholderText()}
// //                                                     value={searchQuery}
// //                                                     onChange={(e) => setSearchQuery(e.target.value)}
// //                                                     style={{ height: "40px" }}
// //                                                 />
// //                                             </div>
// //                                         </div>
// //                                     </div>



// //                                     {/* Clear Filters Button */}
// //                                     <div className="col-md-auto col-12">
// //                                         <button
// //                                             className="btn"
// //                                             onClick={clearAllFilters}
// //                                             style={{
// //                                                 backgroundColor: '#6c757d',
// //                                                 color: '#fff',
// //                                                 height: "40px",
// //                                                 padding: "0 15px"
// //                                             }}
// //                                         >
// //                                             Clear Filters
// //                                         </button>
// //                                     </div>

// //                                     {/* Refresh Data Button */}
// //                                     <div className="col-md col-12">
// //                                         <div className="d-flex justify-content-start justify-content-md-end">
// //                                             <button
// //                                                 className="btn"
// //                                                 onClick={() => window.location.reload()}
// //                                                 style={{
// //                                                     backgroundColor: 'rgb(230 109 51)',
// //                                                     color: '#fff',
// //                                                     height: "40px",
// //                                                     padding: "0 20px"
// //                                                 }}
// //                                             >
// //                                                 Refresh Data
// //                                             </button>
// //                                         </div>
// //                                     </div>
// //                                 </div>

// //                                 <div className="sed pe-3">
// //                                     <table style={tableStyle} className="table table-striped">
// //                                         <thead>
// //                                             <tr>
// //                                                 <th style={thStyle}>S.NO</th>
// //                                                 <th style={thStyle}>Customer Name</th>
// //                                                 <th style={thStyle}>Email</th>
// //                                                 <th style={thStyle}>Mobile</th>
// //                                                 <th style={thStyle}>City</th>
// //                                                 <th style={thStyle}>Business Vertical</th>
// //                                                 <th style={thStyle}>Vendor ID</th>
// //                                                 <th style={thStyle}>Actions</th>
// //                                             </tr>
// //                                         </thead>
// //                                         <tbody>
// //                                             {filteredData.length ? (
// //                                                 filteredData.map((c, idx) => (
// //                                                     <tr key={c.vendorId || idx}>
// //                                                         <td style={thTdStyle}>{idx + 1}</td>

// //                                                         {/* ❌ Not available → use fallback */}
// //                                                         <td style={thTdStyle}>{c?.name || "—"}</td>

// //                                                         <td style={thTdStyle}>{c?.email || "—"}</td>

// //                                                         <td style={thTdStyle}>{c?.mobileNumber || "—"}</td>

// //                                                         {/* ✅ Available */}
// //                                                         <td style={thTdStyle}>{c?.city || "—"}</td>

// //                                                         {/* ✅ Static (since this is engineering API) */}
// //                                                         <td style={thTdStyle}>ENGINEERING_SERVICE</td>

// //                                                         <td style={thTdStyle}>{c?.vendorId || "—"}</td>

// //                                                         <td style={thTdStyle}>
// //                                                             <button
// //                                                                 style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
// //                                                                 onClick={() => handleViewClick(c)}
// //                                                             >
// //                                                                 View
// //                                                             </button>
// //                                                         </td>
// //                                                     </tr>
// //                                                 ))
// //                                             ) : (
// //                                                 <tr>
// //                                                     <td style={thTdStyle} colSpan={8}>
// //                                                         {rolesData.length === 0
// //                                                             ? "Loading data or no customers found."
// //                                                             : (searchQuery.trim() || cityFilter || businessVerticalFilter)
// //                                                                 ? "No data found with the specified filters."
// //                                                                 : "No data available."}
// //                                                     </td>
// //                                                 </tr>
// //                                             )}
// //                                         </tbody>
// //                                     </table>
// //                                 </div>
// //                             </>
// //                         ) : (
// //                             <div className="mt-4 rounded-3 shadow-sm">
// //                                 <div className="d-flex align-items-center mb-4">
// //                                     <button
// //                                         onClick={handleBackClick}
// //                                         className="btn fw-bold px-4 py-2"
// //                                         style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
// //                                     >
// //                                         Back to List
// //                                     </button>
// //                                 </div>

// //                                 {loading && (
// //                                     <div className="text-center my-4">
// //                                         <span className="spinner-border text-primary" />
// //                                     </div>
// //                                 )}

// //                                 {!loading && vendorNotFound && (
// //                                     <div className="text-center my-5 py-5">
// //                                         <div style={{ fontSize: "24px", color: "#dc3545", marginBottom: "16px" }}>
// //                                             ⚠️ Vendor Not Registered
// //                                         </div>
// //                                         <p style={{ fontSize: "16px", color: "#6c757d" }}>
// //                                             This vendor has a subscription but is not registered in the system.
// //                                             <br />
// //                                             Vendor ID: {selectedClient?.vendorId}
// //                                         </p>
// //                                     </div>
// //                                 )}

// //                                 {!loading && !vendorNotFound && vendorDetails && (
// //                                     <div className="register mt-4">
// //                                         <div className="registertable bo2">
// //                                             <table className="table table-bordered table-striped align-middle mt-4 w-100">
// //                                                 <thead>
// //                                                     <tr>
// //                                                         <th style={detailThStyle}>Field</th>
// //                                                         <th style={detailThStyle}>Value</th>
// //                                                         <th style={detailThStyle}>Image</th>
// //                                                         <th style={detailThStyle}>Status</th>
// //                                                     </tr>
// //                                                 </thead>

// //                                                 <tbody>
// //                                                     {rows.map((r, i) => {
// //                                                         const isEditing = r.isEditing || false;

// //                                                         const handleInputChange = (field, value) => {
// //                                                             setRows((prevRows) =>
// //                                                                 prevRows.map((row, idx) =>
// //                                                                     idx === i
// //                                                                         ? {
// //                                                                             ...row,
// //                                                                             value:
// //                                                                                 typeof row.value === "object"
// //                                                                                     ? { ...row.value, [field]: value }
// //                                                                                     : value,
// //                                                                         }
// //                                                                         : row
// //                                                                 )
// //                                                             );
// //                                                         };

// //                                                         // Handle Order Type selection (multiple)
// //                                                         const handleOrderTypeChange = (selectedValue) => {
// //                                                             setRows((prevRows) =>
// //                                                                 prevRows.map((row, idx) => {
// //                                                                     if (idx === i) {
// //                                                                         const currentValues = Array.isArray(row.value) ? row.value : [];
// //                                                                         const isSelected = currentValues.includes(selectedValue);

// //                                                                         if (isSelected) {
// //                                                                             // Remove if already selected
// //                                                                             return {
// //                                                                                 ...row,
// //                                                                                 value: currentValues.filter(v => v !== selectedValue)
// //                                                                             };
// //                                                                         } else {
// //                                                                             // Add if not selected
// //                                                                             return {
// //                                                                                 ...row,
// //                                                                                 value: [...currentValues, selectedValue]
// //                                                                             };
// //                                                                         }
// //                                                                     }
// //                                                                     return row;
// //                                                                 })
// //                                                             );
// //                                                         };

// //                                                         // Handle Business Plan selection
// //                                                         const handleBusinessPlanChange = (selectedValue) => {
// //                                                             setRows((prevRows) =>
// //                                                                 prevRows.map((row, idx) =>
// //                                                                     idx === i
// //                                                                         ? {
// //                                                                             ...row,
// //                                                                             value: selectedValue,
// //                                                                         }
// //                                                                         : row
// //                                                                 )
// //                                                             );
// //                                                         };

// //                                                         // Handle Rating selection
// //                                                         const handleRatingChange = (selectedValue) => {
// //                                                             setRows((prevRows) =>
// //                                                                 prevRows.map((row, idx) =>
// //                                                                     idx === i
// //                                                                         ? {
// //                                                                             ...row,
// //                                                                             value: parseFloat(selectedValue),
// //                                                                         }
// //                                                                         : row
// //                                                                 )
// //                                                             );
// //                                                         };

// //                                                         const handleImageChange = (e) => {
// //                                                             const files = Array.from(e.target.files);
// //                                                             const newImages = files.map((file) => ({
// //                                                                 url: URL.createObjectURL(file),
// //                                                                 file
// //                                                             }));

// //                                                             setRows(prev =>
// //                                                                 prev.map((row, idx) =>
// //                                                                     idx === i
// //                                                                         ? {
// //                                                                             ...row,
// //                                                                             images: [...(row.images || []), ...newImages]
// //                                                                         }
// //                                                                         : row
// //                                                                 )
// //                                                             );
// //                                                         };

// //                                                         // Check if field is editable
// //                                                         const isEditableField = ![
// //                                                             "Selected Modules",
// //                                                             "Remaining Days",
// //                                                             "Business Vertical",
// //                                                             "City"
// //                                                         ].includes(r.key);

// //                                                         return (
// //                                                             <tr key={r.key || i}>
// //                                                                 <td className="fw-bold text-center align-middle">{r.key}</td>

// //                                                                 <td className="text-start align-middle">
// //                                                                     {r.key === "Order Type" ? (
// //                                                                         isEditing ? (
// //                                                                             <div className="d-flex flex-column gap-2">
// //                                                                                 {orderTypeOptions.map((option) => {
// //                                                                                     const currentValues = Array.isArray(r.value) ? r.value : [];
// //                                                                                     const isSelected = currentValues.includes(option);

// //                                                                                     return (
// //                                                                                         <div key={option} className="form-check">
// //                                                                                             <input
// //                                                                                                 className="form-check-input"
// //                                                                                                 type="checkbox"
// //                                                                                                 id={`order-type-${option}-${i}`}
// //                                                                                                 checked={isSelected}
// //                                                                                                 onChange={() => handleOrderTypeChange(option)}
// //                                                                                             />
// //                                                                                             <label
// //                                                                                                 className="form-check-label"
// //                                                                                                 htmlFor={`order-type-${option}-${i}`}
// //                                                                                             >
// //                                                                                                 {option}
// //                                                                                             </label>
// //                                                                                         </div>
// //                                                                                     );
// //                                                                                 })}
// //                                                                             </div>
// //                                                                         ) : (
// //                                                                             Array.isArray(r.value) && r.value.length > 0
// //                                                                                 ? r.value.join(", ")
// //                                                                                 : "N/A"
// //                                                                         )
// //                                                                     ) : r.key === "Business Plan" ? (
// //                                                                         isEditing && isEditableField ? (
// //                                                                             <select
// //                                                                                 value={r.value || ""}
// //                                                                                 onChange={(e) => handleBusinessPlanChange(e.target.value)}
// //                                                                                 className="form-select w-75"
// //                                                                             >
// //                                                                                 <option value="">Select Business Plan</option>
// //                                                                                 {businessPlanOptions.map((option) => (
// //                                                                                     <option key={option} value={option}>
// //                                                                                         {option}
// //                                                                                     </option>
// //                                                                                 ))}
// //                                                                             </select>
// //                                                                         ) : (
// //                                                                             r.value || "N/A"
// //                                                                         )
// //                                                                     ) : r.key === "Rating" ? (
// //                                                                         isEditing && isEditableField ? (
// //                                                                             <select
// //                                                                                 value={r.value || 0}
// //                                                                                 onChange={(e) => handleRatingChange(e.target.value)}
// //                                                                                 className="form-select w-75"
// //                                                                             >
// //                                                                                 {ratingOptions.map((option) => (
// //                                                                                     <option key={option.value} value={option.value}>
// //                                                                                         {option.label}
// //                                                                                     </option>
// //                                                                                 ))}
// //                                                                             </select>
// //                                                                         ) : (
// //                                                                             <div>
// //                                                                                 {r.value || 0} {r.value ? "★" : ""}
// //                                                                             </div>
// //                                                                         )
// //                                                                     ) : r.key === "Company Name" ? (
// //                                                                         <div>
// //                                                                             {isEditing && isEditableField ? (
// //                                                                                 <input
// //                                                                                     type="text"
// //                                                                                     value={r.value || ""}
// //                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
// //                                                                                     className="form-control d-inline-block w-75 mb-2"
// //                                                                                 />
// //                                                                             ) : (
// //                                                                                 r.value || "N/A"
// //                                                                             )}
// //                                                                         </div>
// //                                                                     ) : r.key === "Bank Details" ? (
// //                                                                         ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
// //                                                                             <div key={field} className="mb-1">
// //                                                                                 <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
// //                                                                                 {isEditing && isEditableField ? (
// //                                                                                     <input
// //                                                                                         type="text"
// //                                                                                         value={r.value?.[field] || ""}
// //                                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
// //                                                                                         className="form-control d-inline-block w-75 ms-2"
// //                                                                                     />
// //                                                                                 ) : (
// //                                                                                     r.value?.[field] || "N/A"
// //                                                                                 )}
// //                                                                             </div>
// //                                                                         ))
// //                                                                     ) : r.key === "Address" ? (
// //                                                                         ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
// //                                                                             <div key={field} className="mb-1">
// //                                                                                 <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
// //                                                                                 {isEditing && isEditableField ? (
// //                                                                                     <input
// //                                                                                         type="text"
// //                                                                                         value={r.value?.[field] || ""}
// //                                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
// //                                                                                         className="form-control d-inline-block w-75 ms-2"
// //                                                                                     />
// //                                                                                 ) : (
// //                                                                                     r.value?.[field] || "N/A"
// //                                                                                 )}
// //                                                                             </div>
// //                                                                         ))
// //                                                                     ) : r.key === "Trade License" ||
// //                                                                         r.key === "FSSI License" ||
// //                                                                         r.key === "Labour License" ? (
// //                                                                         <>
// //                                                                             <div className="mb-2">
// //                                                                                 <strong>Start Date:</strong>{" "}
// //                                                                                 {isEditing && isEditableField ? (
// //                                                                                     <input
// //                                                                                         type="date"
// //                                                                                         value={safeDateToISOString(r.value?.startDate)}
// //                                                                                         onChange={(e) => handleInputChange("startDate", e.target.value)}
// //                                                                                         className="form-control d-inline-block w-75 ms-2"
// //                                                                                     />
// //                                                                                 ) : (
// //                                                                                     safeDateDisplay(r.value?.startDate)
// //                                                                                 )}
// //                                                                             </div>
// //                                                                             <div>
// //                                                                                 <strong>End Date:</strong>{" "}
// //                                                                                 {isEditing && isEditableField ? (
// //                                                                                     <input
// //                                                                                         type="date"
// //                                                                                         value={safeDateToISOString(r.value?.endDate)}
// //                                                                                         onChange={(e) => handleInputChange("endDate", e.target.value)}
// //                                                                                         className="form-control d-inline-block w-75 ms-2"
// //                                                                                     />
// //                                                                                 ) : (
// //                                                                                     safeDateDisplay(r.value?.endDate)
// //                                                                                 )}
// //                                                                             </div>
// //                                                                         </>
// //                                                                     ) : r.key === "Trade License Number" ||
// //                                                                         r.key === "Labour License Number" ||
// //                                                                         r.key === "FSSAI License Number" ||
// //                                                                         r.key === "Owner Name" ||
// //                                                                         r.key === "Phone No" ||
// //                                                                         r.key === "Email ID" ||
// //                                                                         r.key === "Website" ||
// //                                                                         r.key === "GST No." ||
// //                                                                         r.key === "AADHAR CARD NO" ||
// //                                                                         r.key === "PAN CARD NO" ? (
// //                                                                         isEditing && isEditableField ? (
// //                                                                             <input
// //                                                                                 type="text"
// //                                                                                 value={r.value || ""}
// //                                                                                 onChange={(e) => handleInputChange("value", e.target.value)}
// //                                                                                 className="form-control d-inline-block w-75"
// //                                                                             />
// //                                                                         ) : (
// //                                                                             r.value || "N/A"
// //                                                                         )
// //                                                                     ) : r.key === "Register Documents" ? (
// //                                                                         "Registered Documents"
// //                                                                     ) : r.key === "Passbook" ? (
// //                                                                         "Passbook Image"
// //                                                                     ) : (
// //                                                                         r.value || "N/A"
// //                                                                     )}
// //                                                                 </td>

// //                                                                 <td className="text-center align-middle">
// //                                                                     {isEditing && isEditableField ? (
// //                                                                         <>
// //                                                                             {r.key === "Company Name" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "Register Documents" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     multiple
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "AADHAR CARD NO" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     multiple
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "PAN CARD NO" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "Trade License" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "FSSI License" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "Labour License" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "Bank Details" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             {r.key === "Passbook" && (
// //                                                                                 <input
// //                                                                                     type="file"
// //                                                                                     accept="image/*"
// //                                                                                     onChange={handleImageChange}
// //                                                                                     className="form-control mb-2"
// //                                                                                 />
// //                                                                             )}
// //                                                                             <ImageDisplay images={r.images} fieldName={r.key} />
// //                                                                         </>
// //                                                                     ) : (
// //                                                                         <ImageDisplay images={r.images} fieldName={r.key} />
// //                                                                     )}
// //                                                                 </td>

// //                                                                 <td className="text-center align-middle">
// //                                                                     {isEditing && isEditableField ? (
// //                                                                         <>
// //                                                                             <button
// //                                                                                 className="btn btn-sm btn-success me-2"
// //                                                                                 style={{ minWidth: 80 }}
// //                                                                                 onClick={() => handleSaveRow(i)}
// //                                                                             >
// //                                                                                 Save
// //                                                                             </button>
// //                                                                             <button
// //                                                                                 className="btn btn-sm btn-secondary"
// //                                                                                 style={{ minWidth: 80 }}
// //                                                                                 onClick={() =>
// //                                                                                     setRows((prev) =>
// //                                                                                         prev.map((row, idx) =>
// //                                                                                             idx === i ? { ...row, isEditing: false } : row
// //                                                                                         )
// //                                                                                     )
// //                                                                                 }
// //                                                                             >
// //                                                                                 Cancel
// //                                                                             </button>
// //                                                                         </>
// //                                                                     ) : (
// //                                                                         <div style={{ display: "flex", gap: "10px" }}>
// //                                                                             {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
// //                                                                                 <button
// //                                                                                     className="btn btn-sm btn-success"
// //                                                                                     style={{ minWidth: 80 }}
// //                                                                                     disabled
// //                                                                                 >
// //                                                                                     Verified ✓
// //                                                                                 </button>
// //                                                                             ) : (
// //                                                                                 <button
// //                                                                                     className="btn btn-sm btn-warning"
// //                                                                                     style={{ minWidth: 80 }}
// //                                                                                     onClick={() => handleVerifyy(i)}
// //                                                                                     disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
// //                                                                                 >
// //                                                                                     Verify
// //                                                                                 </button>
// //                                                                             )}

// //                                                                             {isFieldRejected(r.key, vendorDetails) ? (
// //                                                                                 <button
// //                                                                                     className="btn btn-sm btn-danger"
// //                                                                                     style={{ minWidth: 80 }}
// //                                                                                     disabled
// //                                                                                 >
// //                                                                                     Rejected ✗
// //                                                                                 </button>
// //                                                                             ) : (
// //                                                                                 <button
// //                                                                                     className="btn btn-sm btn-secondary"
// //                                                                                     style={{ minWidth: 80 }}
// //                                                                                     onClick={() => handleReject(i)}
// //                                                                                     disabled={
// //                                                                                         r.key === "Rating" ? true :
// //                                                                                             !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
// //                                                                                             !isEditableField
// //                                                                                     }
// //                                                                                 >
// //                                                                                     Reject
// //                                                                                 </button>
// //                                                                             )}

// //                                                                             {/* Edit button - only show for editable fields */}
// //                                                                             {isEditableField && (
// //                                                                                 <button
// //                                                                                     className="btn btn-sm btn-primary"
// //                                                                                     style={{ minWidth: 80 }}
// //                                                                                     onClick={() =>
// //                                                                                         setRows((prev) =>
// //                                                                                             prev.map((row, idx) =>
// //                                                                                                 idx === i ? { ...row, isEditing: true } : row
// //                                                                                             )
// //                                                                                         )
// //                                                                                     }
// //                                                                                 >
// //                                                                                     Edit
// //                                                                                 </button>
// //                                                                             )}
// //                                                                         </div>
// //                                                                     )}
// //                                                                 </td>
// //                                                             </tr>
// //                                                         );
// //                                                     })}
// //                                                 </tbody>
// //                                             </table>
// //                                         </div>
// //                                     </div>
// //                                 )}

// //                                 <div
// //                                     style={{
// //                                         display: "flex",
// //                                         justifyContent: "center",
// //                                         marginTop: "15px"
// //                                     }}
// //                                 >
// //                                     {vendorDetails?.approvalStatus ? (
// //                                         // ✅ Show ONLY Approved button
// //                                         <button
// //                                             className="btn btn-success"
// //                                             style={{
// //                                                 padding: "8px 20px",
// //                                                 fontWeight: "600",
// //                                                 borderRadius: "6px",
// //                                                 opacity: 0.7,
// //                                                 cursor: "not-allowed"
// //                                             }}
// //                                             disabled
// //                                         >
// //                                             Approved
// //                                         </button>
// //                                     ) : (
// //                                         // ✅ Show ONLY Approve button
// //                                         <button
// //                                             className="btn btn-primary"
// //                                             style={{
// //                                                 padding: "8px 20px",
// //                                                 fontWeight: "600",
// //                                                 borderRadius: "6px"
// //                                             }}
// //                                             onClick={handleApproveAll}
// //                                         >
// //                                             Approve
// //                                         </button>
// //                                     )}
// //                                 </div>
// //                             </div>
// //                         )}
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// // const thTdStyle = { border: "1px solid #ddd", textAlign: "center", padding: "8px", verticalAlign: "middle" };
// // const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold", whiteSpace: "nowrap" };
// // const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

// // const detailThStyle = {
// //     ...thTdStyle,
// //     backgroundColor: "rgb(230 109 51)",
// //     color: "#fff",
// //     fontWeight: 600,
// //     padding: "0.75rem",
// //     verticalAlign: "middle",
// //     border: "1px solid #dee2e6",
// //     textAlign: "center"
// // };

// // export default Engineeringpaidclinets;







// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getEngineeringVendorDetailsAPI,
//     approveEngineeringVendorAPI,
//     getAllEngineeringVendorsAPI,
//     updateFoodVendorDetailsAPI,
//     updateFoodVendorStatusAPI,
// } from "../../../Servicefile/clientManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Back: () => (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polyline points="15 18 9 12 15 6"/>
//         </svg>
//     ),
//     Edit: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
//             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
//         </svg>
//     ),
//     Check: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//             <polyline points="20 6 9 17 4 12"/>
//         </svg>
//     ),
//     X: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Save: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
//             <polyline points="17 21 17 13 7 13 7 21"/>
//             <polyline points="7 3 7 8 15 8"/>
//         </svg>
//     ),
//     Approved: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
//             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
//             <polyline points="22 4 12 14.01 9 11.01"/>
//         </svg>
//     ),
//     Engineering: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <path d="M12 2L2 7l10 5 10-5-10-5z"/>
//             <path d="M2 17l10 5 10-5"/>
//             <path d="M2 12l10 5 10-5"/>
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2"/>
//             <line x1="8" y1="21" x2="16" y2="21"/>
//             <line x1="12" y1="17" x2="12" y2="21"/>
//             <path d="M8 7h8M8 11h6M8 15h4"/>
//         </svg>
//     ),
//     User: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
//             <circle cx="12" cy="7" r="4"/>
//         </svg>
//     ),
//     Email: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="4" width="20" height="16" rx="2"/>
//             <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
//         </svg>
//     ),
//     Phone: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
//         </svg>
//     )
// };

// // ============================================
// // HELPER FUNCTIONS
// // ============================================
// const normalizeImageUrl = (url) => {
//     if (!url || url === "N/A" || typeof url !== 'string') return null;
//     if (url.startsWith('http')) return url;
//     const cleanUrl = url.replace(/^\//, '');
//     return `http://img.maamaas.com:8080/${cleanUrl}`;
// };

// const getDefaultClientDetailsRows = () => [
//     { key: "Owner Name", value: "", isUpload: false },
//     { key: "Business Plan", value: "", isUpload: false },
//     { key: "Company Name", value: "", isUpload: false },
//     { key: "Register Documents", value: "", isUpload: true },
//     { key: "Phone No", value: "", isUpload: false },
//     { key: "Email ID", value: "", isUpload: false },
//     {
//         key: "Bank Details",
//         value: {
//             holderName: "",
//             branchName: "",
//             accountNumber: "",
//             ifscCode: "",
//         },
//         isUpload: false,
//     },
//     { key: "Passbook", value: "", isUpload: true },
//     { key: "AADHAR CARD NO", value: "", isUpload: false },
//     { key: "PAN CARD NO", value: "", isUpload: false },
//     { key: "Website", value: "", isUpload: false },
//     { key: "GST No.", value: "", isUpload: false },
// ];

// const STATUS_FIELD_MAP = {
//     "Owner Name": "ownerNameStatus",
//     "Business Plan": "businessPlanStatus",
//     "Company Name": "registeredNameStatus",
//     "Register Documents": "registeredDocumentsStatus",
//     "Phone No": "mobileNumberStatus",
//     "Email ID": "emailStatus",
//     "AADHAR CARD NO": "aadharNumberStatus",
//     "PAN CARD NO": "panCardStatus",
//     "Website": "websiteNameStatus",
//     "GST No.": "gstNumberStatus",
//     "Trade License": "tradeLicenseStatus",
//     "FSSI License": "fssaiLicenseStatus",
//     "Labour License": "labourLicenseStatus",
//     "Bank Details": "blankChequeStatus",
//     "Passbook": "passbookStatus",
//     "Address": "addressStatus",
//     "Order Type": "orderTypeStatus",
//     "Business Vertical": "businessVerticalStatus",
//     "Rating": "ratingStatus",
//     "Trade License Number": "tradeLicenseStatus",
//     "FSSAI License Number": "fssaiLicenseStatus",
//     "Labour License Number": "labourLicenseStatus",
// };

// const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "TABLE_DINE_IN"];
// const businessPlanOptions = ["HOTEL", "RESTAURANT", "CAFE", "CLOUD_KITCHEN", "FOOD_COURT", "STREET_FOOD", "BAKERY"];
// const businessVerticalOptions = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES", "LOGISTICS_SUPPLY", "FRESH_GROCERIES"];

// const ratingOptions = [
//     { value: 0, label: "0 - Not Rated" },
//     { value: 1, label: "1 ★" },
//     { value: 1.5, label: "1.5 ★" },
//     { value: 2, label: "2 ★" },
//     { value: 2.5, label: "2.5 ★" },
//     { value: 3, label: "3 ★" },
//     { value: 3.5, label: "3.5 ★" },
//     { value: 4, label: "4 ★" },
//     { value: 4.5, label: "4.5 ★" },
//     { value: 5, label: "5 ★" }
// ];

// const safeDateToISOString = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";
//     return date.toISOString().split("T")[0];
// };

// const safeDateDisplay = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";
//     return date.toLocaleDateString();
// };

// const hasValidData = (row, vendorDetails) => {
//     if (!row) return false;
//     const field = row.key;
//     const value = row.value;

//     if (Array.isArray(value)) {
//         return value.length > 0 && value[0] !== "N/A";
//     }
//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }
//     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
//         if (field === "Address" || field === "Bank Details" ||
//             field === "Trade License" || field === "FSSI License" || field === "Labour License") {
//             return Object.values(value).some(val =>
//                 val && val !== "N/A" && val.toString().trim() !== ""
//             );
//         }
//         return Object.keys(value).length > 0;
//     }
//     if (typeof value === 'number') {
//         return value !== undefined && value !== null;
//     }
//     if (value === "Registered Documents" || value === "Passbook Image") {
//         return row.images && row.images.length > 0;
//     }
//     return false;
// };

// const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
//         return vendorDetails[statusField] === true;
//     }

//     const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

//     const alwaysAutoVerifyFields = [
//         "Business Vertical", "Order Type", "Address", "Rating",
//         "Business Plan", "Website", "Phone No", "Email ID", "GST No.",
//         "Trade License Number", "FSSAI License Number", "Labour License Number",
//         "Owner Name", "Company Name", "AADHAR CARD NO", "PAN CARD NO"
//     ];

//     if (alwaysAutoVerifyFields.includes(rowKey)) {
//         return hasValidData(rowForValidation, vendorDetails);
//     }

//     const documentFields = [
//         "Register Documents", "Trade License", "FSSI License",
//         "Labour License", "Bank Details", "Passbook"
//     ];

//     if (documentFields.includes(rowKey)) {
//         return rowImages && rowImages.length > 0;
//     }

//     return false;
// };

// const isFieldRejected = (rowKey, vendorDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];
//     if (!statusField || !vendorDetails) return false;
//     return vendorDetails[statusField] === false;
// };

// const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
//     return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '1px 5px',
      
//         minHeight: '500px'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'rgb(230 109 51)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     select: {
//         padding: '8px 12px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         minWidth: '140px',
//         cursor: 'pointer'
//     },
//     input: {
//         flex: '1',
//         padding: '8px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         background: 'white',
//         minWidth: '180px'
//     },
//     button: {
//         padding: '8px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         fontWeight: '500',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'rgb(230 109 51)',
//         color: 'white'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     buttonSuccess: {
//         background: '#48bb78',
//         color: 'white'
//     },
//     buttonDanger: {
//         background: '#fc8181',
//         color: 'white'
//     },
//     buttonWarning: {
//         background: '#ecc94b',
//         color: '#744210'
//     },
//     buttonOutline: {
//         background: 'transparent',
//         border: '1px solid #e2e8f0',
//         color: '#4a5568'
//     },
//     tableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '500px',
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '900px'
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     th: {
//         padding: '10px 12px',
//         textAlign: 'left',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: '#e66d33',
//         borderBottom: '2px solid #edf2f7',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px'
//     },
//     statusBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '500',
//         letterSpacing: '0.3px'
//     },
//     statusVerified: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     statusPending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     statusRejected: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     detailHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         padding: '16px 0',
//         borderBottom: '2px solid #e9ecef',
//         marginBottom: '16px',
//         flexWrap: 'wrap'
//     },
//     detailTitle: {
//         fontSize: '18px',
//         fontWeight: '600',
//         color: '#2d3748',
//         flex: 1
//     },
//     detailTableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '60vh'
//     },
//     detailTable: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '700px'
//     },
//     detailTh: {
//         padding: '10px 14px',
//         textAlign: 'center',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'rgb(230 109 51)',
//         border: '1px solid #dee2e6'
//     },
//     detailTd: {
//         padding: '10px 14px',
//         border: '1px solid #dee2e6',
//         verticalAlign: 'middle',
//         fontSize: '13px'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     statsBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px',
//         padding: '8px 0 0 0',
//         fontSize: '12px',
//         color: '#718096',
//         flexWrap: 'wrap'
//     },
//     statItem: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px'
//     },
//     statNumber: {
//         fontWeight: '600',
//         color: '#2d3748'
//     },
//     approvalContainer: {
//         display: 'flex',
//         justifyContent: 'center',
//         padding: '20px 0',
//         marginTop: '16px',
//         borderTop: '2px solid #e9ecef'
//     }
// };

// // ============================================
// // MAIN COMPONENT
// // ============================================
// const Engineeringpaidclinets = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const { showLoader, hideLoader } = useLoader();

//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);

//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [vendorDetails, setVendorDetails] = useState(null);
//     const [vendorNotFound, setVendorNotFound] = useState(false);
//     const [vendorError, setVendorError] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [vendorData, setVendorData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const getCurrentVendorId = () => {
//         return (
//             selectedClient?.vendorId ||
//             selectedClient?.vendorEnquiry?.vendorId ||
//             vendorDetails?.vendorId ||
//             null
//         );
//     };

//     const vendorId = getCurrentVendorId();

//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     const fetchVendorDetails = async (vendorId) => {
//         if (!vendorId) return;
//         setLoading(true);
//         setVendorNotFound(false);
//         setVendorError(null);

//         try {
//             const result = await getEngineeringVendorDetailsAPI(vendorId);
//             if (result.vendorNotFound) {
//                 setVendorNotFound(true);
//                 setVendorDetails(null);
//                 setVendorError(result.error);
//                 return;
//             }
//             setVendorDetails(result.data);
//             setVendorNotFound(false);
//             setVendorError(null);
//         } catch (err) {
//             console.error("❌ get-vendor-details error:", err);
//             setVendorNotFound(true);
//             setVendorDetails(null);
//             setVendorError("Vendor not registered");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleApproveAll = async () => {
//         try {
//             const vendorId = selectedClient?.vendorId || vendorDetails?.vendorId;
//             if (!vendorId) {
//                 alert("❌ Vendor ID not found");
//                 return;
//             }
//             await approveEngineeringVendorAPI(vendorId);
//             setVendorDetails((prev) => ({
//                 ...prev,
//                 approvalStatus: true,
//                 approvalRemarks: "Approved",
//             }));
//             alert("✅ Vendor Approved Successfully");
//         } catch (err) {
//             console.error("❌ Approval Error:", err);
//             alert("❌ Failed to approve vendor");
//         }
//     };

//     const handleSaveRow = async (rowIndex) => {
//         try {
//             const vendorId = selectedClient?.vendorId;
//             if (!vendorId) {
//                 console.error("Vendor ID not found");
//                 return;
//             }

//             const row = rows[rowIndex];
//             const formData = new FormData();
//             const vendorData = {};

//             const fieldMapping = {
//                 "Owner Name": "ownerName",
//                 "Phone No": "mobileNumber",
//                 "Website": "websiteName",
//                 "Email ID": "email",
//                 "Company Name": "registeredName",
//                 "AADHAR CARD NO": "aadharNumber",
//                 "PAN CARD NO": "panCardNumber",
//                 "GST No.": "gstNumber",
//                 "Order Type": "orderTypes",
//                 "Business Plan": "businessPlan",
//                 "Trade License Number": "tradeLicenseNumber",
//                 "FSSAI License Number": "fssaiLicenseNumber",
//                 "Labour License Number": "labourLicenseNumber",
//                 "Rating": "rating"
//             };

//             const backendFieldName = fieldMapping[row.key];

//             if (backendFieldName && row.value) {
//                 if (row.key === "Order Type") {
//                     vendorData[backendFieldName] = Array.isArray(row.value) ? row.value : [row.value];
//                 } else if (row.key === "Rating") {
//                     vendorData[backendFieldName] = parseFloat(row.value) || 0;
//                 } else if (row.value !== "N/A") {
//                     vendorData[backendFieldName] = row.value;
//                 }
//             }

//             formData.append(
//                 "vendorData",
//                 new Blob([JSON.stringify(vendorData)], { type: "application/json" })
//             );

//             if (row.images && row.images.length > 0) {
//                 row.images.forEach((img, idx) => {
//                     if (img.file) {
//                         const imageFieldName = getImageFieldName(row.key, idx);
//                         formData.append(imageFieldName, img.file);
//                     }
//                 });
//             }

//             await updateFoodVendorDetailsAPI(vendorId, formData);
//             alert("Data updated successfully!");

//             setRows((prev) =>
//                 prev.map((r, idx) =>
//                     idx === rowIndex ? { ...r, isEditing: false } : r
//                 )
//             );

//             fetchVendorDetails(vendorId);

//         } catch (err) {
//             console.error("Error updating vendor:", err);
//             alert("Error updating data: " + (err.response?.data?.message || err.message));
//         }
//     };

//     const getImageFieldName = (rowKey, imageIndex) => {
//         const fieldMap = {
//             "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
//             "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
//             "PAN CARD NO": "panCard",
//             "Trade License": "tradeLicense",
//             "FSSI License": "fssaiLicense",
//             "Labour License": "labourLicense",
//             "Bank Details": "blankCheque",
//             "Passbook": "passbook",
//             "Company Name": "companyLogo",
//         };
//         return fieldMap[rowKey] || `image${imageIndex + 1}`;
//     };

//     const handleVerifyy = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) return;

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) return alert("Vendor ID is missing");

//         try {
//             const vendorData = {
//                 ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
//                 businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
//                 registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
//                 registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
//                 mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
//                 emailStatus: vendorDetails?.emailStatus ?? false,
//                 aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
//                 panCardStatus: vendorDetails?.panCardStatus ?? false,
//                 websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
//                 gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
//                 tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
//                 fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
//                 labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
//                 blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
//                 passbookStatus: vendorDetails?.passbookStatus ?? false,
//                 addressStatus: vendorDetails?.addressStatus ?? false,
//                 orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
//                 businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
//                 ratingStatus: vendorDetails?.ratingStatus ?? false,
//                 [statusField]: true,
//             };

//             await updateFoodVendorStatusAPI(vendorId, vendorData);
//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: true,
//             }));
//             await fetchVendorDetails(vendorId);
//             alert("Vendor data verified successfully!");
//         } catch (err) {
//             console.error("❌ Verify error:", err);
//             alert(`Failed to update status: ${err.message}`);
//         }
//     };

//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) return;

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) return alert("Vendor ID missing");

//         try {
//             const vendorData = {
//                 ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
//                 businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
//                 registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
//                 registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
//                 mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
//                 emailStatus: vendorDetails?.emailStatus ?? false,
//                 aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
//                 panCardStatus: vendorDetails?.panCardStatus ?? false,
//                 websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
//                 gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
//                 tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
//                 fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
//                 labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
//                 blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
//                 passbookStatus: vendorDetails?.passbookStatus ?? false,
//                 addressStatus: vendorDetails?.addressStatus ?? false,
//                 orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
//                 businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
//                 ratingStatus: vendorDetails?.ratingStatus ?? false,
//                 [statusField]: false,
//             };

//             await updateFoodVendorStatusAPI(vendorId, vendorData);
//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: false,
//             }));
//             await fetchVendorDetails(vendorId);
//             alert("Vendor status rejected successfully!");
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject status: ${err.message}`);
//         }
//     };

//     useEffect(() => {
//         showLoader();
//         getAllEngineeringVendorsAPI()
//             .then((subscriptions) => {
//                 setRolesData(subscriptions);
//                 setFilteredData(subscriptions);
//                 if (subscriptions.length > 0) {
//                     const vendorId = subscriptions[0]?.vendorId;
//                     if (vendorId) {
//                         fetchVendorDetails(vendorId);
//                     }
//                 }
//             })
//             .catch((err) => console.error("Payment fetch error:", err))
//             .finally(() => {
//                 hideLoader();
//             });
//     }, []);

//     useEffect(() => {
//         let result = rolesData;

//         if (cityFilter) {
//             result = result.filter(item => item.city === cityFilter);
//         }

//         if (businessVerticalFilter) {
//             result = result.filter(item => item.businessVertical === businessVerticalFilter);
//         }

//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 let fieldValue;

//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.customerMobile;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email || item.customerEmail;
//                 } else if (searchType === "name") {
//                     fieldValue = item.customerName;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else if (searchType === "businessVertical") {
//                     fieldValue = item.businessVertical;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         setFilteredData(result);
//     }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery]);

//     const uniqueCities = useMemo(() => {
//         const cities = rolesData.map(item => item.city).filter(Boolean);
//         return [...new Set(cities)].sort();
//     }, [rolesData]);

//     const uniqueBusinessVerticals = useMemo(() => {
//         const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
//         return [...new Set(verticals)].sort();
//     }, [rolesData]);

//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setCityFilter("");
//         setBusinessVerticalFilter("");
//         setSearchType("vendorId");
//     };

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search by Vendor ID...";
//             case "name": return "Search by Customer Name...";
//             case "email": return "Search by Email...";
//             case "phoneNumber": return "Search by Mobile...";
//             case "city": return "Search by City...";
//             case "businessVertical": return "Search by Business Vertical...";
//             default: return "Search...";
//         }
//     };

//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Customer Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" },
//         { value: "businessVertical", label: "Business Vertical" }
//     ];

//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const merged = { ...selectedClient, ...(vendorDetails || {}) };

//         const imageMap = {
//             "Register Documents": [
//                 normalizeImageUrl(merged.registeredDocumentsFront),
//                 normalizeImageUrl(merged.registeredDocumentsBack)
//             ].filter(url => url),
//             "AADHAR CARD NO": [
//                 normalizeImageUrl(merged.aadharPhotoFront),
//                 normalizeImageUrl(merged.aadharPhotoBack)
//             ].filter(url => url),
//             "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
//             "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
//             "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
//             "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
//             "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
//             "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
//             "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
//         };

//         const newRows = [
//             { key: "Vendor ID", value: merged.vendorId || "N/A" },
//             { key: "City", value: merged.city || "N/A" },
//             { key: "State", value: merged.state || "N/A" },
//             { key: "Pincode", value: merged.pincode || "N/A" },
//             {
//                 key: "Address",
//                 value: {
//                     doorNo: merged.doorNumber || "N/A",
//                     street: merged.addressLine || "N/A",
//                     landmark: merged.landMark || "N/A",
//                     city: merged.city || "N/A",
//                     state: merged.state || "N/A",
//                     pincode: merged.pincode || "N/A",
//                     latitude: merged.latitude?.toString() || "N/A",
//                     longitude: merged.longitude?.toString() || "N/A",
//                 },
//             },
//             {
//                 key: "Bank Details",
//                 value: {
//                     accountNumber: merged.bankAccountNumber || "N/A",
//                     ifscCode: merged.ifscCode || "N/A",
//                     bankName: merged.bankName || "N/A",
//                     branchName: merged.branchName || "N/A",
//                 },
//             },
//             { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
//             { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
//             { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
//             {
//                 key: "Trade License",
//                 value: {
//                     startDate: merged.tradeLicenseStartDate || "N/A",
//                     endDate: merged.tradeLicenseEndDate || "N/A",
//                 },
//             },
//             { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
//             {
//                 key: "Labour License",
//                 value: {
//                     startDate: merged.labourStartDate || "N/A",
//                     endDate: merged.labourEndDate || "N/A",
//                 },
//             },
//             { key: "GST No.", value: merged.gstNumber || "N/A" },
//             {
//                 key: "Bank Details",
//                 value: {
//                     holderName: merged.holderName || merged.accountHolderName || "N/A",
//                     branchName: merged.branchName || merged.bankName || "N/A",
//                     accountNumber: merged.accountNumber || merged.accountNo || "N/A",
//                     ifscCode: merged.ifscCode || "N/A",
//                 },
//             },
//             { key: "Passbook", value: "Passbook Image" },
//             { key: "Approval Status", value: merged.approvalStatus ? "Approved" : "Pending" },
//             { key: "Remarks", value: merged.approvalRemarks || "N/A" },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setImageLoadErrors(new Set());
//     }, [selectedClient, vendorDetails]);

//     const handleViewClick = (client) => {
//         setSelectedClient(client);
//         const vendorId = client?.vendorId;
//         setVendorNotFound(false);
//         setVendorError(null);
//         fetchVendorDetails(vendorId);
//     };

//     const handleBackClick = () => {
//         setSelectedClient(null);
//         setVendorNotFound(false);
//         setVendorError(null);
//     };

//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: fieldName === "Company Name" ? "80px" : "60px",
//                                     height: fieldName === "Company Name" ? "80px" : "60px",
//                                     borderRadius: "8px",
//                                     objectFit: "cover",
//                                     border: "2px solid #e2e8f0",
//                                     transition: "transform 0.2s ease"
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     // Calculate stats
//     const totalVendors = rolesData.length;
//     const approvedCount = rolesData.filter(v => v.approvalStatus === true).length;
//     const pendingCount = rolesData.filter(v => v.approvalStatus !== true).length;

//     return (
//         <div style={styles.container}>
//             {!selectedClient ? (
//                 <>
                  
                    
//                     {/* Filters */}
//                     <div style={styles.filtersContainer}>
//                         <div style={styles.searchGroup}>
//                             <select
//                                 value={searchType}
//                                 onChange={(e) => setSearchType(e.target.value)}
//                                 style={styles.select}
//                             >
//                                 {searchOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>

//                             <input
//                                 type="text"
//                                 placeholder={getPlaceholderText()}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{
//                                     ...styles.input,
//                                     borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
//                                 }}
//                             />
//                         </div>

//                         <select
//                             value={cityFilter}
//                             onChange={(e) => setCityFilter(e.target.value)}
//                             style={{ ...styles.select, minWidth: '110px' }}
//                         >
//                             <option value="">All Cities</option>
//                             {uniqueCities.map(city => (
//                                 <option key={city} value={city}>{city}</option>
//                             ))}
//                         </select>

//                         <button
//                             onClick={clearAllFilters}
//                             style={{ ...styles.button, ...styles.buttonSecondary }}
//                         >
//                             <Icons.Clear /> Clear
//                         </button>
//                     </div>

//                     {/* Table */}
//                     <div style={styles.tableWrapper}>
//                         <table style={styles.table}>
//                             <thead style={styles.thead}>
//                                 <tr>
//                                     <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
//                                     <th style={styles.th}>Customer</th>
//                                     <th style={styles.th}>Email</th>
//                                     <th style={styles.th}>Mobile</th>
//                                     <th style={styles.th}>City</th>
//                                     <th style={styles.th}>Vertical</th>
//                                     <th style={styles.th}>Vendor ID</th>
//                                     <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredData.length ? (
//                                     filteredData.map((c, idx) => (
//                                         <tr
//                                             key={c.vendorId || idx}
//                                             style={{
//                                                 backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                                 transition: 'background 0.15s ease'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                         >
//                                             <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
//                                             <td style={{ ...styles.td, fontWeight: '500' }}>{c?.name || "—"}</td>
//                                             <td style={{ ...styles.td, color: '#4a5568' }}>{c?.email || "—"}</td>
//                                             <td style={styles.td}>{c?.mobileNumber || "—"}</td>
//                                             <td style={styles.td}>{c?.city || "—"}</td>
//                                             <td style={styles.td}>
//                                                 <span style={{
//                                                     fontSize: '11px',
//                                                     background: '#edf2f7',
//                                                     padding: '2px 8px',
//                                                     borderRadius: '4px',
//                                                     color: '#4a5568'
//                                                 }}>
//                                                     ENGINEERING_SERVICE
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
//                                                 {c?.vendorId || "—"}
//                                             </td>
//                                             <td style={{ ...styles.td, textAlign: 'center' }}>
//                                                 <button
//                                                     style={{
//                                                         ...styles.button,
//                                                         ...styles.buttonPrimary,
//                                                         padding: '4px 14px',
//                                                         height: '32px',
//                                                         fontSize: '12px'
//                                                     }}
//                                                     onClick={() => handleViewClick(c)}
//                                                 >
//                                                     View
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="8" style={{ padding: 0 }}>
//                                             <div style={styles.emptyState}>
//                                                 <Icons.NoData />
//                                                 <div style={styles.emptyStateText}>
//                                                     {rolesData.length === 0 ? 'Loading vendors...' : 'No vendors found'}
//                                                 </div>
//                                                 <div style={styles.emptyStateSubtext}>
//                                                     {rolesData.length === 0
//                                                         ? 'Please wait while we fetch the data'
//                                                         : (searchQuery.trim() || cityFilter || businessVerticalFilter)
//                                                             ? 'Try adjusting your filters to see more results'
//                                                             : 'No engineering paid clients are available'}
//                                                 </div>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </>
//             ) : (
//                 /* ============ DETAIL VIEW ============ */
//                 <div>
//                     {/* Detail Header */}
//                     <div style={styles.detailHeader}>
//                         <button
//                             onClick={handleBackClick}
//                             style={{ ...styles.button, ...styles.buttonPrimary }}
//                         >
//                             <Icons.Back /> Back
//                         </button>
//                         <div style={styles.detailTitle}>
//                             Vendor Details — <span style={{ color: 'rgb(230 109 51)' }}>
//                                 {selectedClient?.name || 'N/A'}
//                             </span>
//                         </div>
//                         {vendorDetails?.approvalStatus ? (
//                             <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
//                                 <Icons.Approved /> Approved
//                             </span>
//                         ) : (
//                             <span style={{ ...styles.statusBadge, ...styles.statusPending }}>
//                                 Pending
//                             </span>
//                         )}
//                     </div>

//                     {loading && (
//                         <div className="text-center my-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                         </div>
//                     )}

//                     {!loading && vendorNotFound && (
//                         <div style={styles.emptyState}>
//                             <div style={{ fontSize: '48px' }}>⚠️</div>
//                             <div style={{ ...styles.emptyStateText, color: '#dc3545' }}>
//                                 Vendor Not Registered
//                             </div>
//                             <div style={styles.emptyStateSubtext}>
//                                 This vendor has a subscription but is not registered in the system.
//                                 <br />
//                                 Vendor ID: <strong>{selectedClient?.vendorId}</strong>
//                             </div>
//                         </div>
//                     )}

//                     {!loading && !vendorNotFound && vendorDetails && (
//                         <>
//                             <div style={styles.detailTableWrapper}>
//                                 <table style={styles.detailTable}>
//                                     <thead>
//                                         <tr>
//                                             <th style={styles.detailTh}>Field</th>
//                                             <th style={styles.detailTh}>Value</th>
//                                             <th style={styles.detailTh}>Image</th>
//                                             <th style={styles.detailTh}>Status</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {rows.map((r, i) => {
//                                             const isEditing = r.isEditing || false;

//                                             const handleInputChange = (field, value) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) =>
//                                                         idx === i
//                                                             ? {
//                                                                 ...row,
//                                                                 value:
//                                                                     typeof row.value === "object"
//                                                                         ? { ...row.value, [field]: value }
//                                                                         : value,
//                                                             }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const handleOrderTypeChange = (selectedValue) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) => {
//                                                         if (idx === i) {
//                                                             const currentValues = Array.isArray(row.value) ? row.value : [];
//                                                             const isSelected = currentValues.includes(selectedValue);

//                                                             if (isSelected) {
//                                                                 return {
//                                                                     ...row,
//                                                                     value: currentValues.filter(v => v !== selectedValue)
//                                                                 };
//                                                             } else {
//                                                                 return {
//                                                                     ...row,
//                                                                     value: [...currentValues, selectedValue]
//                                                                 };
//                                                             }
//                                                         }
//                                                         return row;
//                                                     })
//                                                 );
//                                             };

//                                             const handleBusinessPlanChange = (selectedValue) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) =>
//                                                         idx === i
//                                                             ? { ...row, value: selectedValue }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const handleRatingChange = (selectedValue) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) =>
//                                                         idx === i
//                                                             ? { ...row, value: parseFloat(selectedValue) }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const handleImageChange = (e) => {
//                                                 const files = Array.from(e.target.files);
//                                                 const newImages = files.map((file) => ({
//                                                     url: URL.createObjectURL(file),
//                                                     file
//                                                 }));

//                                                 setRows(prev =>
//                                                     prev.map((row, idx) =>
//                                                         idx === i
//                                                             ? {
//                                                                 ...row,
//                                                                 images: [...(row.images || []), ...newImages]
//                                                             }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const isEditableField = ![
//                                                 "Selected Modules",
//                                                 "Remaining Days",
//                                                 "Business Vertical",
//                                                 "City"
//                                             ].includes(r.key);

//                                             return (
//                                                 <tr key={r.key || i}>
//                                                     <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

//                                                     <td style={styles.detailTd}>
//                                                         {r.key === "Order Type" ? (
//                                                             isEditing ? (
//                                                                 <div className="d-flex flex-column gap-1">
//                                                                     {orderTypeOptions.map((option) => {
//                                                                         const currentValues = Array.isArray(r.value) ? r.value : [];
//                                                                         const isSelected = currentValues.includes(option);
//                                                                         return (
//                                                                             <div key={option} className="form-check">
//                                                                                 <input
//                                                                                     className="form-check-input"
//                                                                                     type="checkbox"
//                                                                                     id={`order-type-${option}-${i}`}
//                                                                                     checked={isSelected}
//                                                                                     onChange={() => handleOrderTypeChange(option)}
//                                                                                 />
//                                                                                 <label className="form-check-label" htmlFor={`order-type-${option}-${i}`}>
//                                                                                     {option}
//                                                                                 </label>
//                                                                             </div>
//                                                                         );
//                                                                     })}
//                                                                 </div>
//                                                             ) : (
//                                                                 Array.isArray(r.value) && r.value.length > 0
//                                                                     ? r.value.join(", ")
//                                                                     : "N/A"
//                                                             )
//                                                         ) : r.key === "Business Plan" ? (
//                                                             isEditing && isEditableField ? (
//                                                                 <select
//                                                                     value={r.value || ""}
//                                                                     onChange={(e) => handleBusinessPlanChange(e.target.value)}
//                                                                     className="form-select"
//                                                                 >
//                                                                     <option value="">Select Business Plan</option>
//                                                                     {businessPlanOptions.map((option) => (
//                                                                         <option key={option} value={option}>{option}</option>
//                                                                     ))}
//                                                                 </select>
//                                                             ) : (
//                                                                 r.value || "N/A"
//                                                             )
//                                                         ) : r.key === "Rating" ? (
//                                                             isEditing && isEditableField ? (
//                                                                 <select
//                                                                     value={r.value || 0}
//                                                                     onChange={(e) => handleRatingChange(e.target.value)}
//                                                                     className="form-select"
//                                                                 >
//                                                                     {ratingOptions.map((option) => (
//                                                                         <option key={option.value} value={option.value}>
//                                                                             {option.label}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             ) : (
//                                                                 <div>{r.value || 0} {r.value ? "★" : ""}</div>
//                                                             )
//                                                         ) : r.key === "Company Name" ? (
//                                                             <div>
//                                                                 {isEditing && isEditableField ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         value={r.value || ""}
//                                                                         onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                         className="form-control mb-1"
//                                                                     />
//                                                                 ) : (
//                                                                     r.value || "N/A"
//                                                                 )}
//                                                             </div>
//                                                         ) : r.key === "Bank Details" ? (
//                                                             ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
//                                                                 <div key={field} className="mb-1">
//                                                                     <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                     {isEditing && isEditableField ? (
//                                                                         <input
//                                                                             type="text"
//                                                                             value={r.value?.[field] || ""}
//                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         r.value?.[field] || "N/A"
//                                                                     )}
//                                                                 </div>
//                                                             ))
//                                                         ) : r.key === "Address" ? (
//                                                             ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
//                                                                 <div key={field} className="mb-1">
//                                                                     <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
//                                                                     {isEditing && isEditableField ? (
//                                                                         <input
//                                                                             type="text"
//                                                                             value={r.value?.[field] || ""}
//                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         r.value?.[field] || "N/A"
//                                                                     )}
//                                                                 </div>
//                                                             ))
//                                                         ) : r.key === "Trade License" ||
//                                                             r.key === "FSSI License" ||
//                                                             r.key === "Labour License" ? (
//                                                             <>
//                                                                 <div className="mb-1">
//                                                                     <strong>Start Date:</strong>{" "}
//                                                                     {isEditing && isEditableField ? (
//                                                                         <input
//                                                                             type="date"
//                                                                             value={safeDateToISOString(r.value?.startDate)}
//                                                                             onChange={(e) => handleInputChange("startDate", e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         safeDateDisplay(r.value?.startDate)
//                                                                     )}
//                                                                 </div>
//                                                                 <div>
//                                                                     <strong>End Date:</strong>{" "}
//                                                                     {isEditing && isEditableField ? (
//                                                                         <input
//                                                                             type="date"
//                                                                             value={safeDateToISOString(r.value?.endDate)}
//                                                                             onChange={(e) => handleInputChange("endDate", e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         safeDateDisplay(r.value?.endDate)
//                                                                     )}
//                                                                 </div>
//                                                             </>
//                                                         ) : r.key === "Trade License Number" ||
//                                                             r.key === "Labour License Number" ||
//                                                             r.key === "FSSAI License Number" ||
//                                                             r.key === "Owner Name" ||
//                                                             r.key === "Phone No" ||
//                                                             r.key === "Email ID" ||
//                                                             r.key === "Website" ||
//                                                             r.key === "GST No." ||
//                                                             r.key === "AADHAR CARD NO" ||
//                                                             r.key === "PAN CARD NO" ? (
//                                                             isEditing && isEditableField ? (
//                                                                 <input
//                                                                     type="text"
//                                                                     value={r.value || ""}
//                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                     className="form-control"
//                                                                 />
//                                                             ) : (
//                                                                 r.value || "N/A"
//                                                             )
//                                                         ) : r.key === "Register Documents" ? (
//                                                             "Registered Documents"
//                                                         ) : r.key === "Passbook" ? (
//                                                             "Passbook Image"
//                                                         ) : (
//                                                             r.value || "N/A"
//                                                         )}
//                                                     </td>

//                                                     <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                         {isEditing && isEditableField ? (
//                                                             <>
//                                                                 {(r.key === "Company Name" || r.key === "Register Documents" ||
//                                                                     r.key === "AADHAR CARD NO" || r.key === "PAN CARD NO" ||
//                                                                     r.key === "Trade License" || r.key === "FSSI License" ||
//                                                                     r.key === "Labour License" || r.key === "Bank Details" ||
//                                                                     r.key === "Passbook") && (
//                                                                         <input
//                                                                             type="file"
//                                                                             multiple={r.key === "Register Documents" || r.key === "AADHAR CARD NO"}
//                                                                             accept="image/*"
//                                                                             onChange={handleImageChange}
//                                                                             className="form-control mb-2"
//                                                                         />
//                                                                     )}
//                                                                 <ImageDisplay images={r.images} fieldName={r.key} />
//                                                             </>
//                                                         ) : (
//                                                             <ImageDisplay images={r.images} fieldName={r.key} />
//                                                         )}
//                                                     </td>

//                                                     <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                         {isEditing && isEditableField ? (
//                                                             <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                                 <button
//                                                                     className="btn btn-sm btn-success"
//                                                                     onClick={() => handleSaveRow(i)}
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     <Icons.Save /> Save
//                                                                 </button>
//                                                                 <button
//                                                                     className="btn btn-sm btn-secondary"
//                                                                     onClick={() =>
//                                                                         setRows((prev) =>
//                                                                             prev.map((row, idx) =>
//                                                                                 idx === i ? { ...row, isEditing: false } : row
//                                                                             )
//                                                                         )
//                                                                     }
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     Cancel
//                                                                 </button>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                                 {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
//                                                                     <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
//                                                                         <Icons.Check /> Verified
//                                                                     </span>
//                                                                 ) : (
//                                                                     <button
//                                                                         className="btn btn-sm btn-warning"
//                                                                         onClick={() => handleVerifyy(i)}
//                                                                         disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
//                                                                         style={{ minWidth: 70 }}
//                                                                     >
//                                                                         Verify
//                                                                     </button>
//                                                                 )}

//                                                                 {isFieldRejected(r.key, vendorDetails) ? (
//                                                                     <span style={{ ...styles.statusBadge, ...styles.statusRejected }}>
//                                                                         <Icons.X /> Rejected
//                                                                     </span>
//                                                                 ) : (
//                                                                     <button
//                                                                         className="btn btn-sm btn-secondary"
//                                                                         onClick={() => handleReject(i)}
//                                                                         disabled={
//                                                                             r.key === "Rating" ? true :
//                                                                                 !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
//                                                                                 !isEditableField
//                                                                         }
//                                                                         style={{ minWidth: 70 }}
//                                                                     >
//                                                                         Reject
//                                                                     </button>
//                                                                 )}

//                                                                 {isEditableField && (
//                                                                     <button
//                                                                         className="btn btn-sm btn-primary"
//                                                                         onClick={() =>
//                                                                             setRows((prev) =>
//                                                                                 prev.map((row, idx) =>
//                                                                                     idx === i ? { ...row, isEditing: true } : row
//                                                                                 )
//                                                                             )
//                                                                         }
//                                                                         style={{ minWidth: 70 }}
//                                                                     >
//                                                                         <Icons.Edit /> Edit
//                                                                     </button>
//                                                                 )}
//                                                             </div>
//                                                         )}
//                                                     </td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             {/* Approval Section */}
//                             <div style={styles.approvalContainer}>
//                                 {vendorDetails?.approvalStatus ? (
//                                     <span style={{ ...styles.statusBadge, ...styles.statusVerified, fontSize: '14px', padding: '6px 20px' }}>
//                                         <Icons.Approved /> Approved ✓
//                                     </span>
//                                 ) : (
//                                     <button
//                                         className="btn btn-success px-4 py-2 fw-bold"
//                                         style={{ minWidth: "120px" }}
//                                         onClick={handleApproveAll}
//                                     >
//                                         <Icons.Check /> Approve
//                                     </button>
//                                 )}
//                             </div>
//                         </>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Engineeringpaidclinets;



import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getEngineeringVendorDetailsAPI,
    approveEngineeringVendorAPI,
    getAllEngineeringVendorsAPI,
    updateFoodVendorDetailsAPI,
    updateFoodVendorStatusAPI,
} from "../../../Servicefile/clientManagementService.jsx";
import { Calendar, ChevronDown } from "lucide-react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Back: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"/>
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Save: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
            <polyline points="17 21 17 13 7 13 7 21"/>
            <polyline points="7 3 7 8 15 8"/>
        </svg>
    ),
    Approved: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    Engineering: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    ),
    Email: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
    ),
    Phone: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
    ),
    Users: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    ),
    CheckCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    XCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
    ),
    Clock: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
};

// Date filter options
const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];

// ============================================
// HELPER FUNCTIONS
// ============================================
const normalizeImageUrl = (url) => {
    if (!url || url === "N/A" || typeof url !== 'string') return null;
    if (url.startsWith('http')) return url;
    const cleanUrl = url.replace(/^\//, '');
    return `http://img.maamaas.com:8080/${cleanUrl}`;
};

const getDefaultClientDetailsRows = () => [
    { key: "Owner Name", value: "", isUpload: false },
    { key: "Business Plan", value: "", isUpload: false },
    { key: "Company Name", value: "", isUpload: false },
    { key: "Register Documents", value: "", isUpload: true },
    { key: "Phone No", value: "", isUpload: false },
    { key: "Email ID", value: "", isUpload: false },
    {
        key: "Bank Details",
        value: {
            holderName: "",
            branchName: "",
            accountNumber: "",
            ifscCode: "",
        },
        isUpload: false,
    },
    { key: "Passbook", value: "", isUpload: true },
    { key: "AADHAR CARD NO", value: "", isUpload: false },
    { key: "PAN CARD NO", value: "", isUpload: false },
    { key: "Website", value: "", isUpload: false },
    { key: "GST No.", value: "", isUpload: false },
];

const STATUS_FIELD_MAP = {
    "Owner Name": "ownerNameStatus",
    "Business Plan": "businessPlanStatus",
    "Company Name": "registeredNameStatus",
    "Register Documents": "registeredDocumentsStatus",
    "Phone No": "mobileNumberStatus",
    "Email ID": "emailStatus",
    "AADHAR CARD NO": "aadharNumberStatus",
    "PAN CARD NO": "panCardStatus",
    "Website": "websiteNameStatus",
    "GST No.": "gstNumberStatus",
    "Trade License": "tradeLicenseStatus",
    "FSSI License": "fssaiLicenseStatus",
    "Labour License": "labourLicenseStatus",
    "Bank Details": "blankChequeStatus",
    "Passbook": "passbookStatus",
    "Address": "addressStatus",
    "Order Type": "orderTypeStatus",
    "Business Vertical": "businessVerticalStatus",
    "Rating": "ratingStatus",
    "Trade License Number": "tradeLicenseStatus",
    "FSSAI License Number": "fssaiLicenseStatus",
    "Labour License Number": "labourLicenseStatus",
};

const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "TABLE_DINE_IN"];
const businessPlanOptions = ["HOTEL", "RESTAURANT", "CAFE", "CLOUD_KITCHEN", "FOOD_COURT", "STREET_FOOD", "BAKERY"];
const businessVerticalOptions = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES", "LOGISTICS_SUPPLY", "FRESH_GROCERIES"];

const ratingOptions = [
    { value: 0, label: "0 - Not Rated" },
    { value: 1, label: "1 ★" },
    { value: 1.5, label: "1.5 ★" },
    { value: 2, label: "2 ★" },
    { value: 2.5, label: "2.5 ★" },
    { value: 3, label: "3 ★" },
    { value: 3.5, label: "3.5 ★" },
    { value: 4, label: "4 ★" },
    { value: 4.5, label: "4.5 ★" },
    { value: 5, label: "5 ★" }
];

const safeDateToISOString = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
};

const safeDateDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleDateString();
};

const hasValidData = (row, vendorDetails) => {
    if (!row) return false;
    const field = row.key;
    const value = row.value;

    if (Array.isArray(value)) {
        return value.length > 0 && value[0] !== "N/A";
    }
    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (field === "Address" || field === "Bank Details" ||
            field === "Trade License" || field === "FSSI License" || field === "Labour License") {
            return Object.values(value).some(val =>
                val && val !== "N/A" && val.toString().trim() !== ""
            );
        }
        return Object.keys(value).length > 0;
    }
    if (typeof value === 'number') {
        return value !== undefined && value !== null;
    }
    if (value === "Registered Documents" || value === "Passbook Image") {
        return row.images && row.images.length > 0;
    }
    return false;
};

const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
        return vendorDetails[statusField] === true;
    }

    const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

    const alwaysAutoVerifyFields = [
        "Business Vertical", "Order Type", "Address", "Rating",
        "Business Plan", "Website", "Phone No", "Email ID", "GST No.",
        "Trade License Number", "FSSAI License Number", "Labour License Number",
        "Owner Name", "Company Name", "AADHAR CARD NO", "PAN CARD NO"
    ];

    if (alwaysAutoVerifyFields.includes(rowKey)) {
        return hasValidData(rowForValidation, vendorDetails);
    }

    const documentFields = [
        "Register Documents", "Trade License", "FSSI License",
        "Labour License", "Bank Details", "Passbook"
    ];

    if (documentFields.includes(rowKey)) {
        return rowImages && rowImages.length > 0;
    }

    return false;
};

const isFieldRejected = (rowKey, vendorDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !vendorDetails) return false;
    return vendorDetails[statusField] === false;
};

const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
    return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        minHeight: '500px'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',
        marginTop: '12px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #edf2f7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease'
    },
    statCardLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    statCardLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    statCardValue: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#0f172a',
        marginTop: '2px',
        lineHeight: '1.2'
    },
    statCardIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 12px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0 12px 0',
    
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonWarning: {
        background: '#ecc94b',
        color: '#744210'
    },
    buttonOutline: {
        background: 'transparent',
        border: '1px solid #e2e8f0',
        color: '#4a5568'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        height: '38px',
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    dateFilterBtnActive: {
        borderColor: '#e66d33',
        color: '#e66d33'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '900px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: '#e66d33',
        borderBottom: '2px solid #edf2f7',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusVerified: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    detailHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 0',
        borderBottom: '2px solid #e9ecef',
        marginBottom: '16px',
        flexWrap: 'wrap'
    },
    detailTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#2d3748',
        flex: 1
    },
    detailTableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh'
    },
    detailTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '700px'
    },
    detailTh: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        border: '1px solid #dee2e6'
    },
    detailTd: {
        padding: '10px 14px',
        border: '1px solid #dee2e6',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    approvalContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '16px',
        borderTop: '2px solid #e9ecef'
    }
};

// ============================================
// MAIN COMPONENT
// ============================================
const Engineeringpaidclinets = () => {
    /* -------- list‑screen state -------- */
    const [rolesData, setRolesData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    // Date filter states - Default "All"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        const date = new Date();
        date.setDate(1);
        return date.toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        approved: 0,
        pending: 0
    });

    /* -------- detail‑screen state -------- */
    const [selectedClient, setSelectedClient] = useState(null);
    const [vendorDetails, setVendorDetails] = useState(null);
    const [vendorNotFound, setVendorNotFound] = useState(false);
    const [vendorError, setVendorError] = useState(null);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState(getDefaultClientDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [vendorData, setVendorData] = useState({});
    const [rowId, setRowId] = useState(null);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const getCurrentVendorId = () => {
        return (
            selectedClient?.vendorId ||
            selectedClient?.vendorEnquiry?.vendorId ||
            vendorDetails?.vendorId ||
            null
        );
    };

    const vendorId = getCurrentVendorId();

    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchVendorDetails = async (vendorId) => {
        if (!vendorId) return;
        setLoading(true);
        setVendorNotFound(false);
        setVendorError(null);

        try {
            const result = await getEngineeringVendorDetailsAPI(vendorId);
            if (result.vendorNotFound) {
                setVendorNotFound(true);
                setVendorDetails(null);
                setVendorError(result.error);
                return;
            }
            setVendorDetails(result.data);
            setVendorNotFound(false);
            setVendorError(null);
        } catch (err) {
            console.error("❌ get-vendor-details error:", err);
            setVendorNotFound(true);
            setVendorDetails(null);
            setVendorError("Vendor not registered");
        } finally {
            setLoading(false);
        }
    };

    const handleApproveAll = async () => {
        try {
            const vendorId = selectedClient?.vendorId || vendorDetails?.vendorId;
            if (!vendorId) {
                alert("❌ Vendor ID not found");
                return;
            }
            await approveEngineeringVendorAPI(vendorId);
            setVendorDetails((prev) => ({
                ...prev,
                approvalStatus: true,
                approvalRemarks: "Approved",
            }));
            alert("✅ Vendor Approved Successfully");
        } catch (err) {
            console.error("❌ Approval Error:", err);
            alert("❌ Failed to approve vendor");
        }
    };

    const handleSaveRow = async (rowIndex) => {
        try {
            const vendorId = selectedClient?.vendorId;
            if (!vendorId) {
                console.error("Vendor ID not found");
                return;
            }

            const row = rows[rowIndex];
            const formData = new FormData();
            const vendorData = {};

            const fieldMapping = {
                "Owner Name": "ownerName",
                "Phone No": "mobileNumber",
                "Website": "websiteName",
                "Email ID": "email",
                "Company Name": "registeredName",
                "AADHAR CARD NO": "aadharNumber",
                "PAN CARD NO": "panCardNumber",
                "GST No.": "gstNumber",
                "Order Type": "orderTypes",
                "Business Plan": "businessPlan",
                "Trade License Number": "tradeLicenseNumber",
                "FSSAI License Number": "fssaiLicenseNumber",
                "Labour License Number": "labourLicenseNumber",
                "Rating": "rating"
            };

            const backendFieldName = fieldMapping[row.key];

            if (backendFieldName && row.value) {
                if (row.key === "Order Type") {
                    vendorData[backendFieldName] = Array.isArray(row.value) ? row.value : [row.value];
                } else if (row.key === "Rating") {
                    vendorData[backendFieldName] = parseFloat(row.value) || 0;
                } else if (row.value !== "N/A") {
                    vendorData[backendFieldName] = row.value;
                }
            }

            formData.append(
                "vendorData",
                new Blob([JSON.stringify(vendorData)], { type: "application/json" })
            );

            if (row.images && row.images.length > 0) {
                row.images.forEach((img, idx) => {
                    if (img.file) {
                        const imageFieldName = getImageFieldName(row.key, idx);
                        formData.append(imageFieldName, img.file);
                    }
                });
            }

            await updateFoodVendorDetailsAPI(vendorId, formData);
            alert("Data updated successfully!");

            setRows((prev) =>
                prev.map((r, idx) =>
                    idx === rowIndex ? { ...r, isEditing: false } : r
                )
            );

            fetchVendorDetails(vendorId);

        } catch (err) {
            console.error("Error updating vendor:", err);
            alert("Error updating data: " + (err.response?.data?.message || err.message));
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
            "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
            "PAN CARD NO": "panCard",
            "Trade License": "tradeLicense",
            "FSSI License": "fssaiLicense",
            "Labour License": "labourLicense",
            "Bank Details": "blankCheque",
            "Passbook": "passbook",
            "Company Name": "companyLogo",
        };
        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    const handleVerifyy = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) return;

        const vendorId = getCurrentVendorId();
        if (!vendorId) return alert("Vendor ID is missing");

        try {
            const vendorData = {
                ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
                businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
                registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
                registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
                mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
                emailStatus: vendorDetails?.emailStatus ?? false,
                aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
                panCardStatus: vendorDetails?.panCardStatus ?? false,
                websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
                gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
                tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
                fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
                labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
                blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
                passbookStatus: vendorDetails?.passbookStatus ?? false,
                addressStatus: vendorDetails?.addressStatus ?? false,
                orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
                businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
                ratingStatus: vendorDetails?.ratingStatus ?? false,
                [statusField]: true,
            };

            await updateFoodVendorStatusAPI(vendorId, vendorData);
            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: true,
            }));
            await fetchVendorDetails(vendorId);
            alert("Vendor data verified successfully!");
        } catch (err) {
            console.error("❌ Verify error:", err);
            alert(`Failed to update status: ${err.message}`);
        }
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) return;

        const vendorId = getCurrentVendorId();
        if (!vendorId) return alert("Vendor ID missing");

        try {
            const vendorData = {
                ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
                businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
                registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
                registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
                mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
                emailStatus: vendorDetails?.emailStatus ?? false,
                aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
                panCardStatus: vendorDetails?.panCardStatus ?? false,
                websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
                gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
                tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
                fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
                labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
                blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
                passbookStatus: vendorDetails?.passbookStatus ?? false,
                addressStatus: vendorDetails?.addressStatus ?? false,
                orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
                businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
                ratingStatus: vendorDetails?.ratingStatus ?? false,
                [statusField]: false,
            };

            await updateFoodVendorStatusAPI(vendorId, vendorData);
            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: false,
            }));
            await fetchVendorDetails(vendorId);
            alert("Vendor status rejected successfully!");
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject status: ${err.message}`);
        }
    };

    // Get date range from selection - Returns null for "All"
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const registerDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!registerDate) return false;
            return registerDate >= startDate && registerDate <= endDate;
        });
    };

    // Calculate Stats
    const calculateStats = (dataArray) => {
        const total = dataArray.length;
        const approved = dataArray.filter(v => v.approvalStatus === true).length;
        const pending = dataArray.filter(v => v.approvalStatus !== true).length;

        setStats({ total, approved, pending });
    };

    useEffect(() => {
        showLoader();
        getAllEngineeringVendorsAPI()
            .then((subscriptions) => {
                setRolesData(subscriptions);
                setFilteredData(subscriptions);
                calculateStats(subscriptions);
                if (subscriptions.length > 0) {
                    const vendorId = subscriptions[0]?.vendorId;
                    if (vendorId) {
                        fetchVendorDetails(vendorId);
                    }
                }
            })
            .catch((err) => console.error("Payment fetch error:", err))
            .finally(() => {
                hideLoader();
            });
    }, []);

    useEffect(() => {
        let result = rolesData;

        // Apply date filter
        result = filterByDateRange(result);

        if (cityFilter) {
            result = result.filter(item => item.city === cityFilter);
        }

        if (businessVerticalFilter) {
            result = result.filter(item => item.businessVertical === businessVerticalFilter);
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.customerMobile;
                } else if (searchType === "email") {
                    fieldValue = item.email || item.customerEmail;
                } else if (searchType === "name") {
                    fieldValue = item.customerName;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else if (searchType === "businessVertical") {
                    fieldValue = item.businessVertical;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(result);
    }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery, selectedDateFilter, customFromDate, customToDate]);

    const uniqueCities = useMemo(() => {
        const cities = rolesData.map(item => item.city).filter(Boolean);
        return [...new Set(cities)].sort();
    }, [rolesData]);

    const uniqueBusinessVerticals = useMemo(() => {
        const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
        return [...new Set(verticals)].sort();
    }, [rolesData]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setCityFilter("");
        setBusinessVerticalFilter("");
        setSearchType("vendorId");
        setSelectedDateFilter("All");
        setCustomFromDate(() => {
            const date = new Date();
            date.setDate(1);
            return date.toISOString().split('T')[0];
        });
        setCustomToDate(new Date().toISOString().split('T')[0]);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Customer Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            case "businessVertical": return "Search by Business Vertical...";
            default: return "Search...";
        }
    };

    const getDateFilterDisplayText = () => {
        if (selectedDateFilter === "All") return "All";
        if (selectedDateFilter === "Custom Range") {
            return `${customFromDate} to ${customToDate}`;
        }
        return selectedDateFilter;
    };

    const handleDateFilterSelect = (filter) => {
        setSelectedDateFilter(filter);
        if (filter === "Custom Range") {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setShowDateDropdown(false);
        }
    };

    const applyCustomRange = () => {
        setShowCustomPicker(false);
        setShowDateDropdown(false);
    };

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Customer Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" },
        { value: "businessVertical", label: "Business Vertical" }
    ];

    useEffect(() => {
        if (!selectedClient) {
            setRows(getDefaultClientDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const merged = { ...selectedClient, ...(vendorDetails || {}) };

        const imageMap = {
            "Register Documents": [
                normalizeImageUrl(merged.registeredDocumentsFront),
                normalizeImageUrl(merged.registeredDocumentsBack)
            ].filter(url => url),
            "AADHAR CARD NO": [
                normalizeImageUrl(merged.aadharPhotoFront),
                normalizeImageUrl(merged.aadharPhotoBack)
            ].filter(url => url),
            "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
            "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
            "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
            "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
            "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
            "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
            "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
        };

        const newRows = [
            { key: "Vendor ID", value: merged.vendorId || "N/A" },
            { key: "City", value: merged.city || "N/A" },
            { key: "State", value: merged.state || "N/A" },
            { key: "Pincode", value: merged.pincode || "N/A" },
            {
                key: "Address",
                value: {
                    doorNo: merged.doorNumber || "N/A",
                    street: merged.addressLine || "N/A",
                    landmark: merged.landMark || "N/A",
                    city: merged.city || "N/A",
                    state: merged.state || "N/A",
                    pincode: merged.pincode || "N/A",
                    latitude: merged.latitude?.toString() || "N/A",
                    longitude: merged.longitude?.toString() || "N/A",
                },
            },
            {
                key: "Bank Details",
                value: {
                    accountNumber: merged.bankAccountNumber || "N/A",
                    ifscCode: merged.ifscCode || "N/A",
                    bankName: merged.bankName || "N/A",
                    branchName: merged.branchName || "N/A",
                },
            },
            { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
            { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
            { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
            {
                key: "Trade License",
                value: {
                    startDate: merged.tradeLicenseStartDate || "N/A",
                    endDate: merged.tradeLicenseEndDate || "N/A",
                },
            },
            { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
            {
                key: "Labour License",
                value: {
                    startDate: merged.labourStartDate || "N/A",
                    endDate: merged.labourEndDate || "N/A",
                },
            },
            { key: "GST No.", value: merged.gstNumber || "N/A" },
            {
                key: "Bank Details",
                value: {
                    holderName: merged.holderName || merged.accountHolderName || "N/A",
                    branchName: merged.branchName || merged.bankName || "N/A",
                    accountNumber: merged.accountNumber || merged.accountNo || "N/A",
                    ifscCode: merged.ifscCode || "N/A",
                },
            },
            { key: "Passbook", value: "Passbook Image" },
            { key: "Approval Status", value: merged.approvalStatus ? "Approved" : "Pending" },
            { key: "Remarks", value: merged.approvalRemarks || "N/A" },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setImageLoadErrors(new Set());
    }, [selectedClient, vendorDetails]);

    const handleViewClick = (client) => {
        setSelectedClient(client);
        const vendorId = client?.vendorId;
        setVendorNotFound(false);
        setVendorError(null);
        fetchVendorDetails(vendorId);
    };

    const handleBackClick = () => {
        setSelectedClient(null);
        setVendorNotFound(false);
        setVendorError(null);
    };

    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "Company Name" ? "80px" : "60px",
                                    height: fieldName === "Company Name" ? "80px" : "60px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "2px solid #e2e8f0",
                                    transition: "transform 0.2s ease"
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div style={styles.container}>
            {!selectedClient ? (
                <>
                   

                    {/* Dashboard Stats Cards */}
                    <div style={styles.statsGrid}>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Total Vendors</span>
                                <span style={styles.statCardValue}>{stats.total}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#eef2ff' }}>
                                <Icons.Users />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Approved</span>
                                <span style={{ ...styles.statCardValue, color: '#16a34a' }}>{stats.approved}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                                <Icons.CheckCircle />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Pending</span>
                                <span style={{ ...styles.statCardValue, color: '#f59e0b' }}>{stats.pending}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#fef3c7' }}>
                                <Icons.Clock />
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <div style={styles.filtersContainer}>
                        <div style={styles.searchGroup}>
                            <select
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={styles.select}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    ...styles.input,
                                    borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                                }}
                            />
                        </div>

                        {/* Date Filter */}
                        <div ref={dateDropdownRef} style={{ position: "relative" }}>
                            <button
                                onClick={() => setShowDateDropdown(!showDateDropdown)}
                                style={{
                                    ...styles.dateFilterBtn,
                                    ...(showDateDropdown ? styles.dateFilterBtnActive : {})
                                }}
                            >
                                <Calendar size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                                <span>{getDateFilterDisplayText()}</span>
                                <ChevronDown size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                            </button>

                            {showDateDropdown && !showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    minWidth: "180px",
                                    overflow: "hidden"
                                }}>
                                    {dateFilterOptions.map(option => (
                                        <div
                                            key={option}
                                            onClick={() => handleDateFilterSelect(option)}
                                            style={{
                                                padding: "10px 16px",
                                                fontSize: "13px",
                                                cursor: "pointer",
                                                background: selectedDateFilter === option ? "#fef3e8" : "white",
                                                color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                                borderBottom: "1px solid #f0f0f0"
                                            }}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    width: "280px",
                                    padding: "16px"
                                }}>
                                    <div style={{ marginBottom: "12px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                        <input
                                            type="date"
                                            value={customFromDate}
                                            onChange={(e) => setCustomFromDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            max={customToDate}
                                        />
                                    </div>
                                    <div style={{ marginBottom: "16px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                        <input
                                            type="date"
                                            value={customToDate}
                                            onChange={(e) => setCustomToDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            min={customFromDate}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <button
                                        onClick={applyCustomRange}
                                        style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                                    >
                                        Apply Range
                                    </button>
                                </div>
                            )}
                        </div>

                        <select
                            value={cityFilter}
                            onChange={(e) => setCityFilter(e.target.value)}
                            style={{ ...styles.select, minWidth: '110px' }}
                        >
                            <option value="">All Cities</option>
                            {uniqueCities.map(city => (
                                <option key={city} value={city}>{city}</option>
                            ))}
                        </select>

                        <button
                            onClick={clearAllFilters}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>

                        {(searchQuery || cityFilter || businessVerticalFilter || selectedDateFilter !== "All") && (
                            <span style={{ fontSize: '12px', color: '#718096' }}>
                                <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
                            </span>
                        )}
                    </div>

                    {/* Table */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                                    <th style={styles.th}>Customer</th>
                                    <th style={styles.th}>Email</th>
                                    <th style={styles.th}>Mobile</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>Vertical</th>
                                    <th style={styles.th}>Vendor ID</th>
                                    <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length ? (
                                    filteredData.map((c, idx) => (
                                        <tr
                                            key={c.vendorId || idx}
                                            style={{
                                                backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                transition: 'background 0.15s ease'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                        >
                                            <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
                                            <td style={{ ...styles.td, fontWeight: '500' }}>{c?.name || "—"}</td>
                                            <td style={{ ...styles.td, color: '#4a5568' }}>{c?.email || "—"}</td>
                                            <td style={styles.td}>{c?.mobileNumber || "—"}</td>
                                            <td style={styles.td}>{c?.city || "—"}</td>
                                            <td style={styles.td}>
                                                <span style={{
                                                    fontSize: '11px',
                                                    background: '#edf2f7',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    color: '#4a5568'
                                                }}>
                                                    ENGINEERING_SERVICE
                                                </span>
                                            </td>
                                            <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                                {c?.vendorId || "—"}
                                            </td>
                                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                                <button
                                                    style={{
                                                        ...styles.button,
                                                        ...styles.buttonPrimary,
                                                        padding: '4px 14px',
                                                        height: '32px',
                                                        fontSize: '12px'
                                                    }}
                                                    onClick={() => handleViewClick(c)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <Icons.NoData />
                                                <div style={styles.emptyStateText}>
                                                    {rolesData.length === 0 ? 'Loading vendors...' : 'No vendors found'}
                                                </div>
                                                <div style={styles.emptyStateSubtext}>
                                                    {rolesData.length === 0
                                                        ? 'Please wait while we fetch the data'
                                                        : (searchQuery.trim() || cityFilter || businessVerticalFilter || selectedDateFilter !== "All")
                                                            ? 'Try adjusting your filters to see more results'
                                                            : 'No engineering paid clients are available'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                /* ============ DETAIL VIEW ============ */
                <div>
                    {/* Detail Header */}
                    <div style={styles.detailHeader}>
                        <button
                            onClick={handleBackClick}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Back /> Back
                        </button>
                        <div style={styles.detailTitle}>
                            Vendor Details — <span style={{ color: 'rgb(230 109 51)' }}>
                                {selectedClient?.name || 'N/A'}
                            </span>
                        </div>
                        {vendorDetails?.approvalStatus ? (
                            <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                <Icons.Approved /> Approved
                            </span>
                        ) : (
                            <span style={{ ...styles.statusBadge, ...styles.statusPending }}>
                                Pending
                            </span>
                        )}
                    </div>

                    {loading && (
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!loading && vendorNotFound && (
                        <div style={styles.emptyState}>
                            <div style={{ fontSize: '48px' }}>⚠️</div>
                            <div style={{ ...styles.emptyStateText, color: '#dc3545' }}>
                                Vendor Not Registered
                            </div>
                            <div style={styles.emptyStateSubtext}>
                                This vendor has a subscription but is not registered in the system.
                                <br />
                                Vendor ID: <strong>{selectedClient?.vendorId}</strong>
                            </div>
                        </div>
                    )}

                    {!loading && !vendorNotFound && vendorDetails && (
                        <>
                            <div style={styles.detailTableWrapper}>
                                <table style={styles.detailTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.detailTh}>Field</th>
                                            <th style={styles.detailTh}>Value</th>
                                            <th style={styles.detailTh}>Image</th>
                                            <th style={styles.detailTh}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((r, i) => {
                                            const isEditing = r.isEditing || false;

                                            const handleInputChange = (field, value) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                value:
                                                                    typeof row.value === "object"
                                                                        ? { ...row.value, [field]: value }
                                                                        : value,
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const handleOrderTypeChange = (selectedValue) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) => {
                                                        if (idx === i) {
                                                            const currentValues = Array.isArray(row.value) ? row.value : [];
                                                            const isSelected = currentValues.includes(selectedValue);

                                                            if (isSelected) {
                                                                return {
                                                                    ...row,
                                                                    value: currentValues.filter(v => v !== selectedValue)
                                                                };
                                                            } else {
                                                                return {
                                                                    ...row,
                                                                    value: [...currentValues, selectedValue]
                                                                };
                                                            }
                                                        }
                                                        return row;
                                                    })
                                                );
                                            };

                                            const handleBusinessPlanChange = (selectedValue) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) =>
                                                        idx === i
                                                            ? { ...row, value: selectedValue }
                                                            : row
                                                    )
                                                );
                                            };

                                            const handleRatingChange = (selectedValue) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) =>
                                                        idx === i
                                                            ? { ...row, value: parseFloat(selectedValue) }
                                                            : row
                                                    )
                                                );
                                            };

                                            const handleImageChange = (e) => {
                                                const files = Array.from(e.target.files);
                                                const newImages = files.map((file) => ({
                                                    url: URL.createObjectURL(file),
                                                    file
                                                }));

                                                setRows(prev =>
                                                    prev.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                images: [...(row.images || []), ...newImages]
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const isEditableField = ![
                                                "Selected Modules",
                                                "Remaining Days",
                                                "Business Vertical",
                                                "City"
                                            ].includes(r.key);

                                            return (
                                                <tr key={r.key || i}>
                                                    <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

                                                    <td style={styles.detailTd}>
                                                        {r.key === "Order Type" ? (
                                                            isEditing ? (
                                                                <div className="d-flex flex-column gap-1">
                                                                    {orderTypeOptions.map((option) => {
                                                                        const currentValues = Array.isArray(r.value) ? r.value : [];
                                                                        const isSelected = currentValues.includes(option);
                                                                        return (
                                                                            <div key={option} className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`order-type-${option}-${i}`}
                                                                                    checked={isSelected}
                                                                                    onChange={() => handleOrderTypeChange(option)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`order-type-${option}-${i}`}>
                                                                                    {option}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            ) : (
                                                                Array.isArray(r.value) && r.value.length > 0
                                                                    ? r.value.join(", ")
                                                                    : "N/A"
                                                            )
                                                        ) : r.key === "Business Plan" ? (
                                                            isEditing && isEditableField ? (
                                                                <select
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleBusinessPlanChange(e.target.value)}
                                                                    className="form-select"
                                                                >
                                                                    <option value="">Select Business Plan</option>
                                                                    {businessPlanOptions.map((option) => (
                                                                        <option key={option} value={option}>{option}</option>
                                                                    ))}
                                                                </select>
                                                            ) : (
                                                                r.value || "N/A"
                                                            )
                                                        ) : r.key === "Rating" ? (
                                                            isEditing && isEditableField ? (
                                                                <select
                                                                    value={r.value || 0}
                                                                    onChange={(e) => handleRatingChange(e.target.value)}
                                                                    className="form-select"
                                                                >
                                                                    {ratingOptions.map((option) => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            ) : (
                                                                <div>{r.value || 0} {r.value ? "★" : ""}</div>
                                                            )
                                                        ) : r.key === "Company Name" ? (
                                                            <div>
                                                                {isEditing && isEditableField ? (
                                                                    <input
                                                                        type="text"
                                                                        value={r.value || ""}
                                                                        onChange={(e) => handleInputChange("value", e.target.value)}
                                                                        className="form-control mb-1"
                                                                    />
                                                                ) : (
                                                                    r.value || "N/A"
                                                                )}
                                                            </div>
                                                        ) : r.key === "Bank Details" ? (
                                                            ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                                                                    {isEditing && isEditableField ? (
                                                                        <input
                                                                            type="text"
                                                                            value={r.value?.[field] || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        r.value?.[field] || "N/A"
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Address" ? (
                                                            ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
                                                                    {isEditing && isEditableField ? (
                                                                        <input
                                                                            type="text"
                                                                            value={r.value?.[field] || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        r.value?.[field] || "N/A"
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Trade License" ||
                                                            r.key === "FSSI License" ||
                                                            r.key === "Labour License" ? (
                                                            <>
                                                                <div className="mb-1">
                                                                    <strong>Start Date:</strong>{" "}
                                                                    {isEditing && isEditableField ? (
                                                                        <input
                                                                            type="date"
                                                                            value={safeDateToISOString(r.value?.startDate)}
                                                                            onChange={(e) => handleInputChange("startDate", e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDateDisplay(r.value?.startDate)
                                                                    )}
                                                                </div>
                                                                <div>
                                                                    <strong>End Date:</strong>{" "}
                                                                    {isEditing && isEditableField ? (
                                                                        <input
                                                                            type="date"
                                                                            value={safeDateToISOString(r.value?.endDate)}
                                                                            onChange={(e) => handleInputChange("endDate", e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDateDisplay(r.value?.endDate)
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : r.key === "Trade License Number" ||
                                                            r.key === "Labour License Number" ||
                                                            r.key === "FSSAI License Number" ||
                                                            r.key === "Owner Name" ||
                                                            r.key === "Phone No" ||
                                                            r.key === "Email ID" ||
                                                            r.key === "Website" ||
                                                            r.key === "GST No." ||
                                                            r.key === "AADHAR CARD NO" ||
                                                            r.key === "PAN CARD NO" ? (
                                                            isEditing && isEditableField ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                r.value || "N/A"
                                                            )
                                                        ) : r.key === "Register Documents" ? (
                                                            "Registered Documents"
                                                        ) : r.key === "Passbook" ? (
                                                            "Passbook Image"
                                                        ) : (
                                                            r.value || "N/A"
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing && isEditableField ? (
                                                            <>
                                                                {(r.key === "Company Name" || r.key === "Register Documents" ||
                                                                    r.key === "AADHAR CARD NO" || r.key === "PAN CARD NO" ||
                                                                    r.key === "Trade License" || r.key === "FSSI License" ||
                                                                    r.key === "Labour License" || r.key === "Bank Details" ||
                                                                    r.key === "Passbook") && (
                                                                        <input
                                                                            type="file"
                                                                            multiple={r.key === "Register Documents" || r.key === "AADHAR CARD NO"}
                                                                            accept="image/*"
                                                                            onChange={handleImageChange}
                                                                            className="form-control mb-2"
                                                                        />
                                                                    )}
                                                                <ImageDisplay images={r.images} fieldName={r.key} />
                                                            </>
                                                        ) : (
                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing && isEditableField ? (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => handleSaveRow(i)}
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Save /> Save
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: false } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                                                        <Icons.Check /> Verified
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-warning"
                                                                        onClick={() => handleVerifyy(i)}
                                                                        disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Verify
                                                                    </button>
                                                                )}

                                                                {isFieldRejected(r.key, vendorDetails) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusRejected }}>
                                                                        <Icons.X /> Rejected
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-secondary"
                                                                        onClick={() => handleReject(i)}
                                                                        disabled={
                                                                            r.key === "Rating" ? true :
                                                                                !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
                                                                                !isEditableField
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Reject
                                                                    </button>
                                                                )}

                                                                {isEditableField && (
                                                                    <button
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() =>
                                                                            setRows((prev) =>
                                                                                prev.map((row, idx) =>
                                                                                    idx === i ? { ...row, isEditing: true } : row
                                                                                )
                                                                            )
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        <Icons.Edit /> Edit
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Approval Section */}
                            <div style={styles.approvalContainer}>
                                {vendorDetails?.approvalStatus ? (
                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified, fontSize: '14px', padding: '6px 20px' }}>
                                        <Icons.Approved /> Approved ✓
                                    </span>
                                ) : (
                                    <button
                                        className="btn btn-success px-4 py-2 fw-bold"
                                        style={{ minWidth: "120px" }}
                                        onClick={handleApproveAll}
                                    >
                                        <Icons.Check /> Approve
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Engineeringpaidclinets;